import React, { Component } from "react";
import { Row, Col, Card, Divider, Button, Input, Select, Image, Switch } from "antd";
import styled from "styled-components";
import {
  BsCalendarMinus,
  MdOutlineBusiness,
  MdContactPhone,
  MdAudiotrack,
  AiOutlinePlaySquare,
  MdNote,
  FaImages,
  BiNote,
  GrTest,
  AiFillStar,
  AiOutlineCloud,
  BsSunFill,
  AiFillCloud,
  BsCircleFill,
  BsFillCameraReelsFill,
  BsExclamationLg,
  CgCrown
} from "react-icons/all";
import { connect } from "react-redux";
import { DashboardAction, UserAction } from "../../store/actions";
import moment from "moment";
import CustomModal from "../../components/modals/customModal";
import Delete_order from "../../assets/images/delete_order.png";
import FileView from "../../components/fileView";
import Configuration from "../../assets/images/configuration.png";
import RadioWrapper from "../../components/RadioWrapper";
import TextInput from "../../components/input/TextInput";
import LoaderGif from "../../assets/images/ie_loader.gif";
import Pickup from "../../assets/images/pickup.png";
import Checklist from "../../assets/images/profile_success.png";
import LeaveSite from "../../assets/images/leavsite.png";
import DropOff from "../../assets/images/dropoff.png";
import Distance from "../../assets/images/distance.png";
import ReactPlayer from "react-player";
import { checkUndefinedOrNull, formatToNumber, getMiles } from "../../config/utils";
import { FileOutlined } from "@ant-design/icons";
import ShippingCost from "../../components/ShpingCost";
import PlacesInput from "../../../contractor/components/placeInput";

const { Option } = Select;
const OrderNumWrapper = styled(Card)`
  min-height: 250px;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 16%);
`;
const { TextArea } = Input;
class OrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenModal: false,
      isOpenReject: false,
      documentModal: false,
      distanceModal: false,
      fileDocument: false,
      testFileDocument: false,
      isOpenLogisticsNotesModal: false,
      isOpenLogisticsFileModal: false,
      isOpenLogisticsTestsModal: false,

      isTesting: false,
      isDistance: false,
      isOpenViewMix: false,
      isDispatchModal: false,
      isAssignModal: false,
      dispatchOrderModal: false,
      logValue: "",
      isSelect: false,
      row: 2,
      isReadMore: false,
      isOpenDeleteModal: false,
      isOpenCheckList: false,
      checkListData: [],
      isdisableDispatch: false,
      isdisableTime: false,
      radioValue: "",
      driver_id: "",
      paver_id: "",
      setHours: "",
      setMin: "",
      customError: {
        driver_id_Error: "",
        paver_id_Error: "",
        subdriver_id_Error: "",
        subPaver_id_Error: "",
        setHours_Error: "",
        setMin_Error: "",
        latitude_Error: "",
        longitude_Error: "",
        radius_Error: "",
        // shippingAddress_Error: "",
      },
      orderViewMix: [],
      viewMixDetail: {},
      listIndex: 0,
      checklistAction: "",
      isVisible: false,
      isVisibleVideo: false,
      videoIndex: 0,
      audioIndex: 0,
      isVisibleAudio: false,
      isVisibleDistance: false,
      attachment: "",
      isOpenNotesModal: false,
      noteShowOnModal: "",
      optionSubdriver: [],
      selectedSubDriver: [],
      selectedSubPaver: [],
      isPaverSelected: false,
      latitude: "",
      longitude: "",
      radius: "",
      shippingAddress: "",
      subDriverToggle: false,
      subPaverToggle: false,
      assestDriverId: "",
      assestPaverId: "",

    };
  }
  componentDidMount() {
    const {
      getAllPavers,
      getOrderDetail,
      match: {
        params: { id },
      },
    } = this.props;
    getOrderDetail(id);
    getAllPavers({ per_page: 1000, });
  }
  onCancelModal = () => {
    this.setState({
      isOpenModal: false,
      isAssignModal: false,
      driver_id: "",
      paver_id: "",
      selectedSubDriver: [],
      selectedSubPaver: [],
      latitude: "",
      longitude: "",
      radius: "",
      shippingAddress: "",
      isPaverSelected: false,
      subDriverToggle: false,
      subPaverToggle: false,
      driver_name: null,
      paver_name: null,
      optionSubdriver: [],
      optionSubPaver: []

    });
  };
  onSubmit = async () => {
    const { driver_id, paver_id, setHours, setMin, customError, radioValue, selectedSubDriver, subDriverToggle, selectedSubPaver, subPaverToggle, latitude, longitude, radius, isPaverSelected } = this.state;
    const {
      postLogisticsOrder,
      assignPaver,
      match: {
        params: { id },
      },
    } = this.props;
    const { OrderDetail } = this.props
    if (OrderDetail?.logistics_order?.status == 2 || OrderDetail?.logistics_order?.status == 3) {
      // const leadDriver = await OrderDetail?.driver_orders?.filter(item => item.is_lead === true)
      // const leadDriverPresentOrNot = await OrderDetail?.driver_orders?.filter(item => item.is_lead == false || item.is_lead == null)
      // const nullLeadValue = OrderDetail?.driver_orders?.filter(item => item.is_lead == null)
      // console.log("nullLeadValue", nullLeadValue);
      // console.log("LEad is HEre", leadDriver);
      // console.log("only Drivers", leadDriverPresentOrNot);
      // if (leadDriver.length > 0) {
      // console.log("Lead Present", leadDriver);
      this.setState({ isOpenModal: false })
      const payload = { lead_driver_id: this.state.driver_id, driver_ids: this.state.selectedSubDriver };
      const paverPayload = { lead_paver_id: this.state.paver_id, paver_ids: this.state.selectedSubPaver, };
      // postLogisticsOrder(id, payload, () => {
      //   this.onCancelModal();
      //   this.props.history.push("/dashboard");
      // });
      postLogisticsOrder(id, payload, () => {
        assignPaver(id, paverPayload, () => {
          this.onCancelModal();
          this.props.history.push("/dashboard");
        });
      });

      // }
      // else if (leadDriverPresentOrNot.length > 0) {

      //   console.log("making lead append", leadDriverPresentOrNot);
      //   this.setState({ isOpenModal: false })
      //   const payload = { lead_driver_id: leadDriverPresentOrNot[0]?.driver_id, driver_ids: this.state.selectedSubDriver };
      //   console.log("payyyll", payload);
      //   postLogisticsOrder(id, payload, () => {
      //     this.onCancelModal();
      //     this.props.history.push("/dashboard");
      //   });
      // }
      return

    }
    else {
      console.log("run 1");

      console.log("setHours.length", this.state.setHours.length);

      const err = { ...customError };
      console.log("insidee", selectedSubDriver);

      if (!radioValue && !driver_id) {
        // console.log("i am select", selectedSubDriver);
        if (selectedSubDriver.length <= 0 && subDriverToggle) {
          err.subdriver_id_Error = "Please select multiple drivers for this order ";
        }
        if (!driver_id) {
          err.driver_id_Error = "Please select Lead driver for this order ";
        }
        // if (!latitude && isPaverSelected == true) {
        //   err.latitude_Error = "Please enter latitude ";
        // }
        // if (!longitude && isPaverSelected == true) {
        //   err.longitude_Error = "Please enter longitude ";
        // }
        // if (!radius && isPaverSelected == true) {
        //   err.radius_Error = "Please enter radius ";
        // }

        this.setState({
          customError: err,
        });
        return;
      }

      else if (radioValue == "start_time") {
        if (
          (!driver_id && !setHours) ||
          (!latitude && !longitude && !radius) ||
          !setMin ||
          setHours > 12 ||
          setMin > 59
        ) {

          console.log("Time", `${setHours}:${setMin}`);
          if (!driver_id) {
            err.driver_id_Error = "Please select Lead driver for this order ";
          }
          if (selectedSubDriver.length <= 0 && subDriverToggle) {
            err.subdriver_id_Error = "Please select multiple drivers for this order ";
          }

          if (!setHours) {
            err.setHours_Error = "Time is required";
          }

          if (!setMin) {
            err.setMin_Error = "Time is required";
          }
          if (setHours > 12) {
            err.setHours_Error = "Invalid Time Format";
          }
          if (setMin > 59) {
            err.setHours_Error = "Invalid Time Format";
          }
          // if (!latitude && isPaverSelected == true) {
          //   err.latitude_Error = "Please enter latitude ";
          // }
          // if (!longitude && isPaverSelected == true) {
          //   err.longitude_Error = "Please enter longitude ";
          // }
          // if (!radius && isPaverSelected == true) {
          //   err.radius_Error = "Please enter radius ";
          // }

          this.setState({
            customError: err,
          });
          return;
        }
      }

      // if (isPaverSelected == true) {
      //   if (!latitude || !longitude || !radius) {
      //     if (!latitude) {
      //       err.latitude_Error = "Please enter latitude ";
      //     }
      //     if (!longitude) {
      //       err.longitude_Error = "Please enter longitude ";
      //     }
      //     if (!radius) {
      //       err.radius_Error = "Please enter radius ";
      //     }
      //     this.setState({
      //       customError: err,
      //     });
      //     return;
      //   }
      // }

      if (subDriverToggle == true) {
        if (selectedSubDriver.length <= 0) {
          err.subdriver_id_Error = "Please select multiple drivers for this order ";

          this.setState({
            customError: err,
          });
          return
        }
      }

      this.setState({ isOpenModal: false })
      const payload = { lead_driver_id: this.state.driver_id, driver_ids: this.state.selectedSubDriver };
      const paverPayload = {
        lead_paver_id: this.state.paver_id, paver_ids: this.state.selectedSubPaver,
        // geo_fence_latitude: Number(latitude), geo_fence_longitude: Number(longitude), geo_fence_radius: Number(radius), is_geo_fence_active: true 
      };

      // console.log("payloaddddddddddd", payload);
      if (this.state.radioValue) {
        payload["start_time"] = `${setHours}:${setMin}`;
        paverPayload["start_time"] = `${setHours}:${setMin}`;
      }
      // postLogisticsOrder(id, payload, () => {
      //   this.props.dispatchPendingOrder(id, payload, () => {
      //     this.onCancelModal();
      //     this.props.history.push("/dashboard");
      //   })

      // });

      // console.log("paverPayload", paverPayload);
      if (this.state?.paver_id) {
        postLogisticsOrder(id, payload, () => {
          this.props.dispatchPendingOrder(id, payload, () => {
            assignPaver(id, paverPayload, () => {
              this.onCancelModal();
              this.props.history.push("/dashboard");
            })

          })
        }
        );
        // assignPaver(id, paverPayload, () => console.log("paver assigned"));
      }
      else {
        postLogisticsOrder(id, payload, () => {
          this.props.dispatchPendingOrder(id, payload, () => {
            this.onCancelModal();
            this.props.history.push("/dashboard");
          })

        });
      }
    }
  };

  componentDidUpdate(preProps) {
    if (preProps.match.params.id !== this.props.match.params.id) {
      this.props.getOrderDetail(this.props.match.params.id);
    }
  }
  render() {


    // console.log("stateee", this.state);
    console.log("error", this.state.customError);
    var assetsCount = 0

    const {
      OrderDetail,
      approvedOrder,
      logistics,
      pavers,
      paversLoading,
      postLogisticsOrder,
      assignPaver,
      match: {
        params: { id },
      },
      dispatchPendingOrder
    } = this.props;
    const {
      setHours,
      setMin,
      customError,
      orderViewMix,
      viewMixDetail,
      checkListData,
      listIndex,
      checklistAction,
      isOpenCheckList,
      videoIndex,
      isVisibleAudio,
      audioIndex,
      optionSubdriver,
      isPaverSelected,

    } = this.state;
    const { meta_asset = {} } = OrderDetail;


    // console.log('pavers',pavers,paversLoading);
    // Extracting unique ids from arr1
    let arr1Ids = OrderDetail?.driver_orders?.map(obj => obj.user.id);

    // Filtering out objects from arr2 with userable_id not present in arr1Ids
    let orderDetailDocument = OrderDetail?.order_assets?.documents?.filter(obj => !arr1Ids?.includes(obj.userable_id));
    let orderDetailTestDocument = OrderDetail?.order_assets?.test_documents?.filter(obj => !arr1Ids?.includes(obj.userable_id));


    let inputRef;
    console.log("selectedSubDriver", orderDetailDocument);

    // const result = OrderDetail?.driver_orders?.filter(obj1 => logistics.some(obj2 => obj2.driver_id === obj1.id));
    const result = logistics?.filter(obj1 =>
      OrderDetail?.driver_orders?.every(obj2 => obj2.driver_id !== obj1.id)
    );
    const leadAlreadyAssigned = OrderDetail?.driver_orders?.filter(obj1 => obj1.is_lead == true)

    console.log("filterrr driver", leadAlreadyAssigned);


    const filterViewMix = (orderViewMix || []).filter((item) => item.selected);
    console.log("meta_asset?.distance", meta_asset?.distance);
    return (
      <>
        {OrderDetail?.id ? (
          <Row justify="space-around" style={{ marginTop: "20px" }}>
            <Col xl={9} md={24} lg={10} xs={24} sm={24}>
              <OrderNumWrapper>
                <Row align="middle">
                  <Col xl={2} xs={4} sm={3} md={1} lg={2}>
                    <span
                      style={{
                        border:
                          OrderDetail?.preferred_delivery_period === "pm"
                            ? "solid grey 2px"
                            : "solid red 2px",
                        width: "25px",
                        height: "25px",
                      }}
                      className={
                        OrderDetail?.preferred_delivery_period === "pm"
                          ? " am-pm-circle text-left"
                          : " am-pm-circle text-left"
                      }
                    >
                      {OrderDetail?.preferred_delivery_period === "am" ? (
                        <BsExclamationLg color="red" size={15} />
                      ) : (
                        <BsExclamationLg color="grey" size={15} />
                      )}
                    </span>
                  </Col>
                  <Col xl={22} md={23} lg={20} xxl={18} className="text-left">
                    <h5>{`Order# ${OrderDetail?.order_number}`}</h5>
                  </Col>
                  <Col xl={22} md={22} lg={23} xxl={22} className="text-left">
                    <span >
                      {OrderDetail.purchase_order_num ?
                        `PO#: ${OrderDetail.purchase_order_num} ` : ""
                      }
                    </span>
                  </Col>
                  <Col
                    xl={
                      OrderDetail?.logistics_order?.status == 1 ||
                        OrderDetail?.logistics_order?.status == 4
                        ? 4
                        : OrderDetail?.logistics_order?.status == 2 ||
                          OrderDetail?.logistics_order?.status == 5
                          ? 5
                          : 3
                    }
                    lg={6}
                    xxl={6}
                    md={3}
                    className="text-left"
                  >
                    <span
                      style={{ padding: "2px 2px" }}
                      className={
                        OrderDetail.status == 2 || OrderDetail.status === 6
                          ? "orange order-status-label"
                          : "green order-status-label"
                      }
                    >
                      {OrderDetail?.logistics_order?.status == 1 && "PENDING"}
                      {OrderDetail?.logistics_order?.status == 2 &&
                        "DISPATCHED"}
                      {OrderDetail?.logistics_order?.status === 3 && "PICKED"}
                      {OrderDetail?.logistics_order?.status === 4 && "DROPPED"}
                      {OrderDetail?.logistics_order?.status === 5 &&
                        "COMPLETED"}
                    </span>
                  </Col>
                  <Col
                    xl={19}
                    lg={18}
                    xxl={18}
                    md={18}
                    className="text-left"
                    style={{ marginTop: "5px" }}
                  >
                    <span style={{ paddingRight: "5px" }}>
                      <BsCalendarMinus size="13" color="grey" />
                    </span>
                    <span style={{ color: "#9e9e9e" }}>
                      {moment(OrderDetail?.preferred_delivery_datetime).format(
                        "LL"
                      )}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col xl={22} md={23} lg={20} xxl={18} className="text-left">
                    <h6 className="driver-paver-status-heading">Driver's Status</h6>
                  </Col>
                </Row>
                <Row>
                  <Col span={24} style={{ marginTop: "1rem" }}>
                    {!!OrderDetail?.order_dispatch_details?.length &&
                      (OrderDetail?.order_dispatch_details || [])
                        .filter(item => item.action !== "start_project" && item.action !== "end_project")
                        .map(
                          (item) => {
                            return (
                              <Row
                                align="middle"
                                style={{
                                  background:
                                    item.action === "pick_order"
                                      ? "#eaebed"
                                      : item.action === "drop_order"
                                        ? "#f0f1f3"
                                        : "#f7f8fa",
                                  padding: "1rem",
                                }}
                              >
                                <Col style={{ height: "55px" }} span={24}>
                                  <Row>
                                    <Col span={4} className="text-left">
                                      <img
                                        src={
                                          item.action === "pick_order"
                                            ? Pickup
                                            : item.action === "drop_order"
                                              ? DropOff
                                              : LeaveSite
                                        }
                                      />
                                    </Col>
                                    <Col span={10} className="text-left">
                                      <h3>
                                        {item.action === "pick_order"
                                          ? "Pickup from Plant"
                                          : item.action === "drop_order"
                                            ? "Dropoff at Site"
                                            : "Leaving Site"}
                                      </h3>
                                      <span>
                                        {moment(item?.data?.datetime).format(
                                          "MM-DD-YYYY hh:mm:ss"
                                        )}
                                      </span>
                                    </Col>
                                    <Col span={4}>
                                      <img
                                        src={Checklist}
                                        height={"35"}
                                        width={"30"}
                                      />
                                      <p
                                        className="checklist-color pointer-cursor"
                                        style={{ fontSize: "12px" }}
                                        onClick={() => {
                                          this.setState({
                                            isOpenCheckList: true,
                                            checkListData: item?.data?.checklist,
                                            listIndex: 0,
                                            checklistAction: item?.action,
                                          });
                                        }}
                                      >
                                        Checklist
                                      </p>
                                    </Col>
                                    <Col span={2} className="m-auto">
                                      {item.action === "pick_order" ? (
                                        <AiOutlineCloud
                                          size={"30"}
                                          color="grey"
                                        />
                                      ) : item.action === "drop_order" ? (
                                        <BsSunFill size={"30"} color="grey" />
                                      ) : (
                                        <AiFillCloud size={"30"} color="grey" />
                                      )}
                                    </Col>
                                    <Col span={4} className="m-auto">
                                      <span>
                                        {item.data?.currently?.apparentTemperature ?
                                          `${Math.round((item.data?.currently?.apparentTemperature * 9) / 5 + 32)} °F`
                                          :
                                          "_"
                                        }
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            );
                          }
                        )}
                  </Col>
                </Row>
                <Row>
                  <Col xl={22} md={23} lg={20} xxl={18} className="text-left">
                    <h6 className="driver-paver-status-heading">Paver's Status</h6>
                  </Col>
                </Row>

                <Row>
                  <Col span={24} style={{ marginTop: "1rem" }}>
                    {!!OrderDetail?.order_dispatch_details?.length &&
                      (OrderDetail?.order_dispatch_details || [])
                        .filter(item => item.action == "start_project" || item.action == "end_project")
                        .map(
                          (item) => {
                            return (
                              <Row
                                align="middle"
                                style={{
                                  background:
                                    item.action === "pick_order"
                                      ? "#eaebed"
                                      : item.action === "drop_order"
                                        ? "#f0f1f3"
                                        : "#f7f8fa",
                                  padding: "1rem",
                                }}
                              >
                                <Col style={{ height: "55px" }} span={24}>
                                  <Row>
                                    <Col span={4} className="text-left">
                                      <img
                                        src={
                                          item.action === "pick_order"
                                            ? Pickup
                                            : item.action === "drop_order"
                                              ? DropOff
                                              : LeaveSite
                                        }
                                      />
                                    </Col>
                                    <Col span={10} className="text-left">
                                      <h3>
                                        {item.action === "start_project"
                                          ? "Arrival of Paver"
                                          : item.action === "end_project"
                                            ? "Completion"
                                            : "Leaving Site"}
                                      </h3>
                                      <span>
                                        {moment(item?.data?.datetime).format(
                                          "MM-DD-YYYY hh:mm:ss"
                                        )}
                                      </span>
                                    </Col>
                                    <Col span={4}>
                                      {/* <img
                                      src={Checklist}
                                      height={"35"}
                                      width={"30"}
                                    />
                                    <p
                                      className="checklist-color pointer-cursor"
                                      style={{ fontSize: "12px" }}
                                      onClick={() => {
                                        this.setState({
                                          isOpenCheckList: true,
                                          checkListData: item?.data?.checklist,
                                          listIndex: 0,
                                          checklistAction: item?.action,
                                        });
                                      }}
                                    >
                                      Checklist
                                    </p> */}
                                    </Col>
                                    <Col span={2} className="m-auto">
                                      {item.action === "pick_order" ? (
                                        <AiOutlineCloud
                                          size={"30"}
                                          color="grey"
                                        />
                                      ) : item.action === "drop_order" ? (
                                        <BsSunFill size={"30"} color="grey" />
                                      ) : (
                                        <AiFillCloud size={"30"} color="grey" />
                                      )}
                                    </Col>
                                    <Col span={4} className="m-auto">
                                      <span>
                                        {item.data?.currently?.apparentTemperature ?
                                          `${Math.round((item.data?.currently?.apparentTemperature * 9) / 5 + 32)} °F`
                                          :
                                          "_"
                                        }
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            );
                          }
                        )}
                  </Col>
                </Row>
                <Row>
                  <Col span={24}></Col>
                  <Divider />
                </Row>
                {/* logistics asstes will show here */}
                <Row
                  style={{
                    paddingBottom: "10px",
                    paddingTop: "10px",

                    alignItems: "baseline"

                  }}
                >
                  <Col span={24}>
                    <Row>
                      <Col span={16} className="text-left" style={{ paddingTop: "25px" }}>
                        <h5 className="text-left">Order Assets</h5>
                      </Col>
                      {/* <Col>
                        <Row style={{ display: "inline" }}>
                          <Col
                            className="contractor-avatar pointer-cursor text-center"
                            style={{ background: "#4CAF50" }}
                          >
                            <FileOutlined
                              color="white"
                              size="20"
                              onClick={() => {
                                if (OrderDetail?.note) {
                                  this.setState({
                                    // assestDriverId: item?.user.id,
                                    isOpenLogisticsNotesModal: true
                                  });
                                }
                              }}
                            />
                          </Col>
                          <Col className="pointer-cursor text-center"
                            onClick={() => {
                              if (OrderDetail?.note) {
                                this.setState({
                                  // assestDriverId: item?.user.id,
                                  isOpenLogisticsNotesModal: true
                                });
                              }
                            }}
                          >
                            <small
                              className="small"
                            >
                              {OrderDetail.note ? 1 : 0} Notes
                            </small>

                          </Col>
                        </Row>
                      </Col> */}
                      <Col
                        span={4}
                        style={{ paddingTop: "12px" }}
                        className="text-left"
                      >
                        <Col>

                          <Row style={{ display: "inline" }}>
                            <Col
                              className="contractor-avatar pointer-cursor text-center"
                              style={{ background: "#FF9F00" }}
                            >
                              <BiNote
                                color="white"
                                size="20"
                                onClick={() =>
                                  this.setState({
                                    isOpenLogisticsFileModal: true,
                                  })
                                }
                              />
                            </Col>
                            <Col
                              className="pointer-cursor"
                              onClick={() =>
                                this.setState({
                                  isOpenLogisticsFileModal: true,
                                })
                              }
                            >
                              <small className="small" style={{ paddingLeft: "0.3rem" }}>
                                {orderDetailDocument?.length} Files
                              </small>
                            </Col>
                          </Row>

                        </Col>
                      </Col>
                      <Col
                        span={3}
                        style={{ paddingTop: "12px" }}
                        className="text-left"
                      >
                        <Col>
                          <Row style={{ display: "inline" }}>
                            <Col
                              className="contractor-avatar pointer-cursor"
                              style={{ background: "#01D1FE" }}
                            >
                              <GrTest
                                color="white"
                                size="20"
                                onClick={() =>
                                  this.setState({
                                    isOpenLogisticsTestsModal: true,
                                    isTesting: true,
                                  })
                                }
                              />
                            </Col>
                            <Col
                              className="pointer-cursor"
                              onClick={() =>
                                this.setState({
                                  isOpenLogisticsTestsModal: true,
                                  isTesting: true,
                                })
                              }
                            >
                              <small className="small" >
                                {orderDetailTestDocument?.length} Testing
                              </small>
                            </Col>
                          </Row>
                        </Col>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}></Col>
                  <Divider />
                </Row>



                <Row style={{ marginTop: "10px" }}>
                  <Col>
                    <h6 class="ordercsh">Plant Info</h6>
                  </Col>
                </Row>
                <Row>
                  <Col className="plant-avatar">
                    <MdOutlineBusiness size="20" color="white" />
                  </Col>
                  <Col xl={20}>
                    <h5
                      className="text-left"
                      style={{ marginLeft: "14px", fontSize: "18px" }}
                    >
                      {`${OrderDetail?.rmx_company?.business_name}`}
                    </h5>
                    <p className="text-left" style={{ marginLeft: "14px" }}>
                      <small style={{ fontSize: "85%", color: "#000000DE" }}>
                        {`${OrderDetail?.rmx_company?.email}`}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "90%" }}>
                        {`${OrderDetail?.rmx_company?.address}`}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "90%" }}>
                        {`${checkUndefinedOrNull(formatToNumber(
                          OrderDetail?.rmx_company?.phone || ""
                        ))}`}
                      </small>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}></Col>
                  <Divider />
                </Row>


                <Row align="middle">
                  <Col span={24} className="text-left">
                    <h6 class="ordercsh">Contractor Info</h6>
                  </Col>
                </Row>
                <Row>
                  <Col className="contractor-avatar">
                    <MdOutlineBusiness size="20" color="white" />
                  </Col>
                  <Col span={20}>
                    <h5
                      className="text-left"
                      style={{ marginLeft: "14px", fontSize: "18px" }}
                    >
                      {`${OrderDetail?.contractor?.user?.first_name} ${OrderDetail?.contractor?.user?.last_name}`}
                    </h5>
                    <p className="text-left" style={{ marginLeft: "14px" }}>
                      <small style={{ fontSize: "90%" }}>
                        {`${OrderDetail?.contractor?.user?.email}`}
                      </small>
                      <br></br>
                      {/* <small style={{ fontSize: "90%" }}>
                        {`${OrderDetail?.contractor?.user?.address ? OrderDetail?.contractor?.user?.address : '-'}`}
                      </small>
                      <br></br> */}
                      <small style={{ fontSize: "90%" }}>
                        {`${checkUndefinedOrNull(formatToNumber(
                          OrderDetail?.contractor?.user?.phone
                        ))}`}
                      </small>
                    </p>
                  </Col>
                </Row>


                <Row>
                  <Col span={24}></Col>
                  <Divider />
                </Row>

                <Row>
                  <Col span={24} className="text-left">
                    <h6 class="ordercsh">Shipping Address</h6>
                  </Col>
                </Row>
                <Row>
                  <Col className="contractor-avatar">
                    <MdContactPhone size="20" color="white" />
                  </Col>
                  <Col span={20}>
                    <h5
                      className="text-left"
                      style={{ marginLeft: "14px", fontSize: "16px" }}
                    >
                      {`${OrderDetail?.order_addresses?.[1]?.contractors_address?.name ? OrderDetail?.order_addresses?.[1]?.contractors_address?.name : "-"}`}
                    </h5>
                    <p className="text-left" style={{ marginLeft: "14px" }}>
                      <small style={{ fontSize: "90%" }}>
                        {`${OrderDetail?.order_addresses?.[1]?.contractors_address?.contact_person ? OrderDetail?.order_addresses?.[1]?.contractors_address?.contact_person : "-"}`}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "85%", color: "#000000DE" }}>
                        {`${checkUndefinedOrNull(OrderDetail?.order_addresses?.[1]?.contractors_address?.address)}`}
                        {/* {`${}`} */}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "85%", color: "#000000DE" }}>
                        {`${checkUndefinedOrNull(formatToNumber(
                          OrderDetail?.order_addresses?.[1]?.contractors_address
                            ?.phone
                        ))}`}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "85%", color: "#000000DE" }}>
                        {`${checkUndefinedOrNull(OrderDetail?.order_addresses?.[1]?.contractors_address?.email)}`}
                        {/* {`${}`} */}
                      </small>
                    </p>
                  </Col>
                </Row>





                <Row>
                  <Col span={24} className="text-left">
                    <h6 class="ordercsh">Billing Address</h6>
                  </Col>
                </Row>
                <Row>
                  <Col className="contractor-avatar">
                    <MdContactPhone size="20" color="white" />
                  </Col>
                  <Col span={20}>
                    <h5
                      className="text-left"
                      style={{ marginLeft: "14px", fontSize: "16px" }}
                    >
                      {`${OrderDetail?.order_addresses?.[0]?.contractors_address?.name ? OrderDetail?.order_addresses?.[0]?.contractors_address?.name : "-"}`}
                    </h5>
                    <p className="text-left" style={{ marginLeft: "14px" }}>
                      <small style={{ fontSize: "90%" }}>
                        {`${OrderDetail?.order_addresses?.[0]?.contractors_address?.contact_person ? OrderDetail?.order_addresses?.[0]?.contractors_address?.contact_person : "-"}`}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "85%", color: "#000000DE" }}>
                        {`${checkUndefinedOrNull(OrderDetail?.order_addresses?.[0]?.contractors_address?.address)}`}
                        {/* {`${}`} */}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "85%", color: "#000000DE" }}>
                        {`${checkUndefinedOrNull(formatToNumber(
                          OrderDetail?.order_addresses?.[0]?.contractors_address
                            ?.phone
                        ))}`}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "85%", color: "#000000DE" }}>
                        {`${checkUndefinedOrNull(OrderDetail?.order_addresses?.[0]?.contractors_address?.email)}`}
                        {/* {`${OrderDetail?.order_addresses?.[0]?.contractors_address?.email}`} */}
                      </small>
                    </p>
                  </Col>
                </Row>




                {/* <Row>
                  <Col span={24}></Col>
                  <Divider />
                </Row> */}

                <Row>
                  <Col span={24}></Col>
                  <Divider />
                </Row>
                {/* <Row style={{ marginTop: "10px" }}>
                  <Col span={24}>
                    <h3 className="text-left orderdetail-heading">
                      MEDIA ADDED
                    </h3>
                  </Col>
                  {/* <Col xl={24} xs={24} sm={24} md={24} lg={24}>
                    <Row justify="space-around">
                      <Col
                        className="contractor-avatar pointer-cursor text-center"
                        style={{ background: "#5C6BC0" }}
                        onClick={() => {
                          if (OrderDetail?.meta_asset?.audios) {
                            this.setState({ isVisibleAudio: true });
                          }
                        }}
                      >
                        <MdAudiotrack color="white" size="20" />
                      </Col>
                      <Col
                        className="contractor-avatar pointer-cursor text-center"
                        style={{ background: "#2196F3" }}
                      >
                        <AiOutlinePlaySquare
                          color="white"
                          size="20"
                          onClick={() => {
                            if (OrderDetail?.meta_asset?.videos) {
                              this.setState({
                                isVisibleVideo: true,
                              });
                            }
                          }}
                        />
                      </Col>

                      <Col
                        className="contractor-avatar pointer-cursor text-center"
                        style={{ background: "#4CAF50" }}
                      >
                        <MdNote
                          color="white"
                          size="20"
                          onClick={() =>
                            OrderDetail?.note &&
                            this.setState({
                              isOpenNotesModal: true,
                            })
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={24} xs={24} sm={24} md={24} lg={24}>
                    <Row justify="space-around">
                      <Col
                        span={8}
                        className="pointer-cursor text-center"
                        onClick={() => {
                          if (OrderDetail?.meta_asset?.audios) {
                            this.setState({ isVisibleAudio: true });
                          }
                        }}
                      >
                        <small className="small">
                          {meta_asset.audios} Audios
                        </small>
                      </Col>
                      <Col span={8} className="pointer-cursor text-center">
                        <small
                          className="small"
                          onClick={() => {
                            if (OrderDetail?.meta_asset?.videos) {
                              this.setState({ isVisibleVideo: true });
                            }
                          }}
                        >
                          {meta_asset.videos} Videos
                        </small>
                      </Col>
                      <Col
                        span={8}
                        className="pointer-cursor text-center"
                        onClick={() =>
                          OrderDetail?.note &&
                          this.setState({
                            isOpenNotesModal: true,
                          })
                        }
                      >
                        <small className="small">Notes</small>
                      </Col>
                    </Row>
                    <Row justify="space-around" style={{ marginTop: "1rem" }}>
                      <Col
                        className="contractor-avatar pointer-cursor text-center  "
                        style={{ background: "#E91E63" }}
                      >
                        <FaImages
                          color="white"
                          size="20"
                          onClick={() => {
                            if (OrderDetail?.meta_asset?.images)
                              this.setState({ isVisible: true });
                          }}
                        />
                      </Col>

                      <Col
                        className="contractor-avatar pointer-cursor text-center"
                        style={{ background: "#FF9F00" }}
                      >
                        <BiNote
                          color="white"
                          size="20"
                          onClick={() =>
                            this.setState({
                              documentModal: true,
                            })
                          }
                        />
                      </Col>

                      <Col
                        className="contractor-avatar pointer-cursor"
                        style={{ background: "#01D1FE" }}
                      >
                        <GrTest
                          color="white"
                          size="20"
                          onClick={() =>
                            this.setState({
                              documentModal: true,
                              isTesting: true,
                            })
                          }
                        />
                      </Col>
                      <Col xl={24} xs={24} sm={24} md={24} lg={24}>
                        <Row justify="space-around">
                          <Col
                            span={8}
                            className="pointer-cursor text-center"
                            onClick={() => {
                              if (OrderDetail?.meta_asset?.images)
                                this.setState({ isVisible: true });
                            }}
                          >
                            <small className="small">
                              {meta_asset.images} Images
                            </small>
                          </Col>
                          <Col
                            span={8}
                            className="pointer-cursor text-center"
                            onClick={() =>
                              this.setState({
                                documentModal: true,
                              })
                            }
                          >
                            <small className="small">
                              {meta_asset?.documents} Files
                            </small>
                          </Col>
                          <Col
                            span={8}
                            className="pointer-cursor text-center"
                            onClick={() =>
                              this.setState({
                                documentModal: true,
                                isTesting: true,
                              })
                            }
                          >
                            <small className="small">
                              {meta_asset?.test_documents} Testing
                            </small>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col> */}
                {/* </Row> */}
              </OrderNumWrapper>
            </Col>
            <Col xl={14} md={24} lg={13} xs={24} sm={24}>
              <OrderNumWrapper>
                <Row gutter={[0, 10]} style={{ marginBottom: "10px" }}>
                  <Col span={24} style={{ marginBottom: "10px" }}>
                    <Row>
                      <Col span={18} lg={20}>
                        <h5 className="text-left">Order Details</h5>
                      </Col>
                      {OrderDetail.status === 7 && (
                        <Col span={4} lg={4}>
                          <h6
                            style={{ fontWeight: "720", fontSize: "11px" }}
                            className="text-left"
                          >
                            {OrderDetail?.driver_orders?.user ? "Driver" : ""}
                          </h6>
                          <h3
                            className="text-left"
                            style={{ fontSize: "0.9rem" }}
                          >
                            {OrderDetail?.driver_orders?.user?.first_name}{" "}
                            {OrderDetail?.driver_orders?.user?.last_name}
                          </h3>
                        </Col>
                      )}
                      {OrderDetail.status === 6 && (
                        <>
                          <Col span={3} className="text-right">
                            <h6
                              style={{ fontWeight: "720", fontSize: "11px" }}
                              className="text-left"
                            >
                              {OrderDetail?.driver_orders?.user ? "Driver" : ""}
                            </h6>
                            <h3
                              className="text-left"
                              style={{ fontSize: "0.9rem" }}
                            >
                              {OrderDetail?.driver_orders?.user?.first_name}{" "}
                              {OrderDetail?.driver_orders?.user?.last_name}
                            </h3>
                          </Col>
                        </>
                      )}
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row
                      className="ordertable-heading"
                      style={{ height: "40px" }}
                      align="middle"
                    >
                      <Col span={16} className="text-left">
                        <span
                          className="text-left color-light-grey"
                          style={{
                            textTransform: "uppercase",
                            color: "#9b9ea4",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          PRODUCT
                        </span>
                      </Col>
                      <Col span={4} className="text-left">
                        <span
                          className="color-light-grey"
                          style={{
                            textTransform: "uppercase",
                            color: "#9b9ea4",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          QUANTITY
                        </span>
                      </Col>
                      <Col span={4} className="text-left">
                        <span
                          className="color-light-grey"
                          style={{
                            textTransform: "uppercase",
                            color: "#9b9ea4",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          ACTION
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {OrderDetail?.order_products?.length ? (
                  (OrderDetail?.order_products || []).map((item) => {
                    let total_amount = item?.order_product_additives?.filter(
                      (v) => {
                        return v.selected;
                      }
                    );
                    let p = 0;
                    let c = (total_amount || []).map((d) => {
                      p = p + Number(d.rmx_product_additive.price);
                      return p;
                    });
                    return (
                      <Row
                        style={{
                          paddingBottom: "10px",
                          paddingTop: "10px",
                          borderBottom: "1px solid #d0d0d0 ",
                          alignItems: "baseline"

                        }}
                      >
                        <Col span={24}>
                          <Row>
                            <Col span={2} className="text-left">
                              <img
                                width={"52px"}
                                height={"52px"}
                                src={item?.rmx_product?.image?.medium}
                              />
                            </Col>
                            <Col
                              span={14}
                              // lg={12}
                              // xs={24}
                              // sm={24}
                              // md={20}
                              // lg={14}
                              className="text-left"
                            // style={{ paddingTop: "12px" }}
                            >
                              <span className="rmx-product-detail-name">
                                {item?.rmx_product?.name}
                              </span>
                            </Col>
                            <Col
                              span={4}
                              style={{ paddingTop: "12px" }}
                              className="text-left"
                            >
                              <span>
                                {`${item?.quantity} ${item?.rmx_product?.unit}`}{" "}
                              </span>
                            </Col>
                            <Col
                              span={4}
                              style={{ paddingTop: "12px" }}
                              className="text-left"
                            >
                              <span
                                className="view-link pointer-cursor"
                                onClick={() =>
                                  this.setState({
                                    isOpenViewMix: true,
                                    orderViewMix: item.order_product_additives,
                                    viewMixDetail: item,
                                  })
                                }
                                style={{ fontSize: "0.70rem" }}
                              >
                                VIEW MIX
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    );
                  })
                ) : (
                  <Row>
                    <Col
                      className="text-left"
                      span={24}
                      style={{
                        borderBottom: "1px solid #d0d0d0 ",
                        paddingBottom: "10px",
                        paddingTop: "10px",
                        paddingLeft: "10px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "16px",
                          color: "d0d0d0 ",
                        }}
                      >
                        No records found
                      </span>
                    </Col>
                  </Row>
                )}







              </OrderNumWrapper>




              <OrderNumWrapper
                // style={{
                //   marginTop: 10,
                //   overflowY: "scroll",
                //   overflowX: "hidden",
                //   height: 300,
                // }}
                className={OrderDetail?.driver_orders?.length > 2 ? "details-scroll" : ""}
              >
                <Row>
                  {/* {OrderDetail?.logistics_order?.status == 1 || OrderDetail?.logistics_order?.status == 2 ?
                     "": */}
                  <Col span={18} lg={20}>
                    <h5 className="text-left">Driver Details</h5>
                  </Col>
                  {/* } */}
                  <Col span={24}>
                    <Row
                      // justify="center"
                      className="ordertable-heading"
                      style={{ height: "40px" }}
                      align="middle"
                    >
                      <Col span={12} className="text-left">
                        <span
                          className="text-left color-light-grey"
                          style={{
                            textTransform: "uppercase",
                            color: "#9b9ea4",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          NAME
                        </span>
                      </Col>

                      <Col span={12} className="text-left">
                        <span
                          className="color-light-grey"
                          style={{
                            textTransform: "uppercase",
                            color: "#9b9ea4",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          MEDIA DETAILS
                        </span>
                      </Col>
                    </Row>
                  </Col>

                  <Row
                    // justify= "center"
                    style={{ width: "100%", marginTop: 20 }}
                    className={OrderDetail?.driver_orders?.length > 2 ? "media-height" : ""}
                  >
                    {OrderDetail?.driver_orders?.map((item, index) => {
                      return (
                        <>
                          {/* {OrderDetail?.logistics_order?.status == 1 || OrderDetail?.logistics_order?.status == 2 ?
                            "": */}
                          <Col
                            xl={8}
                            xs={8}
                            sm={8}
                            md={8}
                            lg={8}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingLeft: 2,
                              marginTop: 10,
                              // border: "solid",
                              wordBreak: "break-all",
                              borderBottom: "1px solid rgb(208, 208, 208)",
                            }}
                          >

                            {!OrderDetail?.driver_orders ? (
                              <span style={{ paddingLeft: 20 }}>-----</span>
                            ) : (
                              <span style={{ display: "flex", alignItems: "center" }}>
                                {/* {OrderDetail?.driver_orders?.user?.first_name}{" "}
                                {OrderDetail?.driver_orders?.user?.last_name} */}

                                {
                                  // console.log("maxxxx", OrderDetail?.driver_orders[index]),
                                  OrderDetail?.driver_orders[index]?.is_lead == true ?
                                    <>
                                      <span style={{ display: "flex", alignItems: "center", fontWeight: "bold" }}>
                                        {OrderDetail?.driver_orders[index]?.user?.first_name} {OrderDetail?.driver_orders[index]?.user?.last_name}
                                        <CgCrown size="30px" style={{ marginLeft: '5px' }} />
                                      </span>

                                    </>
                                    : <> {OrderDetail?.driver_orders[index]?.user?.first_name} {OrderDetail?.driver_orders[index]?.user?.last_name} </>
                                }
                              </span>
                            )}
                          </Col>

                          <Col
                            xl={16}
                            xs={16}
                            sm={16}
                            md={16}
                            lg={16}
                            style={{
                              borderBottom: "1px solid rgb(208, 208, 208)",
                              marginTop: 10,
                            }}
                          >
                            <Col span={24}>
                              <Row justify="space-around"


                              >
                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center"
                                      style={{ background: "#4CAF50" }}
                                    >
                                      <FileOutlined
                                        color="white"
                                        size="20"
                                        onClick={() => {

                                          // (OrderDetail?.note || []).map((itm) => {

                                          if (item?.note) {
                                            this.setState({
                                              // assestDriverId: item?.user.id,
                                              noteShowOnModal: item?.note,
                                              isOpenNotesModal: true

                                            });
                                          }
                                          // })
                                        }
                                        }
                                      />
                                    </Col>
                                    <Col className="pointer-cursor text-center"
                                      onClick={() => {
                                        // (OrderDetail?.note || []).map((itm) => {

                                        if (item?.note) {
                                          this.setState({
                                            // assestDriverId: item.user.id,
                                            noteShowOnModal: item?.note,
                                            isOpenNotesModal: true

                                          });
                                        }
                                        // })
                                      }}

                                    >
                                      <div style={{ display: "none" }}>
                                        {
                                          item?.note != null ? ++assetsCount : assetsCount = 0
                                        }
                                      </div>

                                      {/* {
                                        (OrderDetail?.note || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      } */}
                                      <small
                                        className="small"
                                      >
                                        {assetsCount} Notes
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>

                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center"
                                      style={{ background: "#5C6BC0" }}
                                    >
                                      <MdAudiotrack color="white" size="20"

                                        onClick={() => {

                                          (OrderDetail?.order_assets?.audios || []).map((itm) => {

                                            if (itm.userable_id == item.user.id) {
                                              this.setState({
                                                assestDriverId: item.user.id,
                                                isVisibleAudio: true

                                              });
                                            }
                                          })

                                        }}


                                      />
                                    </Col>
                                    <Col
                                      // span={3}
                                      // style={{ marginTop: 20 }}
                                      className="pointer-cursor text-center"
                                      onClick={() => {

                                        (OrderDetail?.order_assets?.audios || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            this.setState({
                                              assestDriverId: item.user.id,
                                              isVisibleAudio: true

                                            });
                                          }
                                        })
                                      }}
                                    >
                                      {
                                        (OrderDetail?.order_assets?.audios || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      }
                                      <small className="small">
                                        {assetsCount} Audios
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center"
                                      style={{ background: "#2196F3" }}
                                    >
                                      <AiOutlinePlaySquare
                                        color="white"
                                        size="20"
                                        onClick={() => {

                                          (OrderDetail?.order_assets?.videos || []).map((itm) => {

                                            if (itm.userable_id == item.user.id) {
                                              this.setState({
                                                assestDriverId: item.user.id,
                                                isVisibleVideo: true

                                              });
                                            }
                                          })
                                        }
                                        }
                                      />
                                    </Col>
                                    <Col className="pointer-cursor text-center"
                                      onClick={() => {
                                        (OrderDetail?.order_assets?.videos || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            this.setState({
                                              assestDriverId: item.user.id,
                                              isVisibleVideo: true

                                            });
                                          }
                                        })
                                      }}

                                    >
                                      {
                                        (OrderDetail?.order_assets?.videos || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      }
                                      <small
                                        className="small"
                                      >
                                        {assetsCount} Videos
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center  "
                                      style={{ background: "#E91E63" }}
                                    >
                                      <FaImages
                                        color="white"
                                        size="20"
                                        onClick={() => {

                                          {
                                            (OrderDetail?.order_assets?.images || []).map((itm) => {

                                              if (itm.userable_id == item.user.id) {
                                                if (OrderDetail.meta_asset.images > 0) {
                                                  this.setState({ assestDriverId: item.user.id, isVisible: true });

                                                }
                                              }
                                            })
                                          }
                                        }}
                                      />
                                    </Col>
                                    <Col
                                      className="pointer-cursor text-center"
                                      onClick={() => {

                                        {
                                          (OrderDetail?.order_assets?.images || []).map((itm) => {

                                            if (itm.userable_id == item.user.id) {

                                              if (OrderDetail.meta_asset.images > 0) {

                                                this.setState({ assestDriverId: item.user.id, isVisible: true });
                                              }
                                            }
                                          })
                                        }
                                      }}
                                    >

                                      {
                                        (OrderDetail?.order_assets?.images || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      }

                                      <small className="small">
                                        {assetsCount} Images
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>

                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center"
                                      style={{ background: "#FF9F00" }}
                                    >
                                      <BiNote
                                        color="white"
                                        size="20"
                                        onClick={() =>
                                          this.setState({
                                            documentModal: true,
                                            assestDriverId: item.user.id,
                                          })
                                        }
                                      />
                                    </Col>
                                    <Col
                                      className="pointer-cursor text-center"
                                      onClick={() =>
                                        this.setState({
                                          documentModal: true,
                                          assestDriverId: item.user.id,
                                        })
                                      }
                                    >
                                      {
                                        (OrderDetail?.order_assets?.documents || []).map((itm) => {
                                          // console.log("looooo count", item.userable_id, item.user.id);
                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      }
                                      <small className="small">
                                        {assetsCount} Files
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>

                                {/* Testing Icon For Driver */}
                                {/* <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor"
                                      style={{ background: "#01D1FE" }}
                                    >
                                      <GrTest
                                        color="white"
                                        size="20"
                                        onClick={() =>
                                          this.setState({
                                            documentModal: true,
                                            isTesting: true,
                                          })
                                        }
                                      />
                                    </Col>
                                    <Col
                                      className="pointer-cursor text-center"
                                      onClick={() =>
                                        this.setState({
                                          documentModal: true,
                                          isTesting: true,
                                        })
                                      }
                                    >
                                      <small className="small">
                                        {meta_asset?.test_documents} Testing
                                      </small>
                                    </Col>
                                  </Row>
                                </Col> */}


                                < Col >
                                  <Row style={{ display: "inline" }}
                                    onClick={() => {
                                      // if (typeof (item?.distance) == "number") {
                                      this.setState({
                                        distanceModal: true,
                                        isDistance: true,
                                        assestDriverId: item.user.id
                                      });
                                      // }
                                    }}
                                  >
                                    <Col
                                      className="contractor-avatar pointer-cursor"
                                      style={{ background: "#ff9800" }}
                                    >
                                      {/* <GrTest
                                        color="white"
                                        size="20"
                                        onClick={() =>
                                          this.setState({
                                            documentModal: true,
                                            isTesting: true,
                                          })
                                        }
                                      /> */}
                                      <img
                                        src={Distance}
                                        width={30}
                                        height={30}
                                      />
                                    </Col>
                                    {console.log(
                                      "meta_asset?.distance",
                                      item?.distance
                                    )}
                                    <Col
                                      className="pointer-cursor text-center"
                                    >
                                      <small className="small">
                                        {getMiles(item?.distance).toFixed(2)}
                                        mi
                                      </small>
                                    </Col>
                                  </Row>
                                </Col>

                              </Row>
                            </Col >
                          </Col>
                        </>
                      );
                    })}
                  </Row>
                </Row>
              </OrderNumWrapper >

              {/* paver detail */}

              <OrderNumWrapper
                // style={{
                //   marginTop: 10,
                //   overflowY: "scroll",
                //   overflowX: "hidden",
                //   height: 300,
                // }}
                className={OrderDetail?.paver_orders?.length > 2 ? "details-scroll" : ""}
              >
                <Row>
                  {/* {OrderDetail?.logistics_order?.status == 1 || OrderDetail?.logistics_order?.status == 2 ?
                     "": */}
                  <Col span={18} lg={20}>
                    <h5 className="text-left">Paver Details</h5>
                  </Col>
                  {/* } */}
                  <Col span={24}>
                    <Row
                      // justify="center"
                      className="ordertable-heading"
                      style={{ height: "40px" }}
                      align="middle"
                    >
                      <Col span={12} className="text-left">
                        <span
                          className="text-left color-light-grey"
                          style={{
                            textTransform: "uppercase",
                            color: "#9b9ea4",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          NAME
                        </span>
                      </Col>

                      <Col span={12} className="text-left">
                        <span
                          className="color-light-grey"
                          style={{
                            textTransform: "uppercase",
                            color: "#9b9ea4",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          MEDIA DETAILS
                        </span>
                      </Col>
                    </Row>
                  </Col>

                  <Row
                    // justify= "center"
                    style={{ width: "100%", marginTop: 20 }}
                    className={OrderDetail?.paver_orders?.length > 2 ? "media-height" : ""}
                  >
                    {OrderDetail?.paver_orders?.map((item, index) => {
                      return (
                        <>
                          {/* {OrderDetail?.logistics_order?.status == 1 || OrderDetail?.logistics_order?.status == 2 ?
                            "": */}
                          <Col
                            xl={8}
                            xs={8}
                            sm={8}
                            md={8}
                            lg={8}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingLeft: 2,
                              marginTop: 10,
                              // border: "solid",
                              wordBreak: "break-all",
                              borderBottom: "1px solid rgb(208, 208, 208)",
                            }}
                          >

                            {!OrderDetail?.paver_orders ? (
                              <span style={{ paddingLeft: 20 }}>-----</span>
                            ) : (
                              <span style={{ display: "flex", alignItems: "center" }}>
                                {/* {OrderDetail?.driver_orders?.user?.first_name}{" "}
                                {OrderDetail?.driver_orders?.user?.last_name} */}

                                {
                                  // console.log("maxxxx", OrderDetail?.driver_orders[index]),
                                  OrderDetail?.paver_orders[index]?.is_lead == true ?
                                    <>
                                      <span style={{ display: "flex", alignItems: "center", fontWeight: "bold" }}>
                                        {OrderDetail?.paver_orders[index]?.user?.first_name} {OrderDetail?.paver_orders[index]?.user?.last_name}
                                        <CgCrown size="30px" style={{ marginLeft: '5px' }} />
                                      </span>

                                    </>
                                    : <> {OrderDetail?.paver_orders[index]?.user?.first_name} {OrderDetail?.paver_orders[index]?.user?.last_name} </>
                                }
                              </span>
                            )}
                          </Col>

                          <Col
                            xl={16}
                            xs={16}
                            sm={16}
                            md={16}
                            lg={16}
                            style={{
                              borderBottom: "1px solid rgb(208, 208, 208)",
                              marginTop: 10,
                            }}
                          >
                            <Col span={24}>
                              <Row justify="space-around"


                              >
                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center"
                                      style={{ background: "#4CAF50" }}
                                    >
                                      <FileOutlined
                                        color="white"
                                        size="20"
                                        onClick={() => {

                                          // (OrderDetail?.note || []).map((itm) => {

                                          if (item?.note) {
                                            this.setState({
                                              // assestDriverId: item?.user.id,
                                              noteShowOnModal: item?.note,
                                              isOpenNotesModal: true

                                            });
                                          }
                                          // })
                                        }
                                        }
                                      />
                                    </Col>
                                    <Col className="pointer-cursor text-center"
                                      onClick={() => {
                                        // (OrderDetail?.note || []).map((itm) => {

                                        if (item?.note) {
                                          this.setState({
                                            // assestDriverId: item.user.id,
                                            noteShowOnModal: item?.note,
                                            isOpenNotesModal: true

                                          });
                                        }
                                        // })
                                      }}

                                    >
                                      <div style={{ display: "none" }}>
                                        {
                                          item?.note != null ? ++assetsCount : assetsCount = 0
                                        }
                                      </div>

                                      {/* {
                                        (OrderDetail?.note || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      } */}
                                      <small
                                        className="small"
                                      >
                                        {assetsCount} Notes
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>

                                {/* <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center"
                                      style={{ background: "#5C6BC0" }}
                                    >
                                      <MdAudiotrack color="white" size="20"

                                        onClick={() => {

                                          (OrderDetail?.order_assets?.audios || []).map((itm) => {

                                            if (itm.userable_id == item.user.id) {
                                              this.setState({
                                                assestDriverId: item.user.id,
                                                isVisibleAudio: true

                                              });
                                            }
                                          })

                                        }}


                                      />
                                    </Col>
                                    <Col
                                      // span={3}
                                      // style={{ marginTop: 20 }}
                                      className="pointer-cursor text-center"
                                      onClick={() => {

                                        (OrderDetail?.order_assets?.audios || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            this.setState({
                                              assestDriverId: item.user.id,
                                              isVisibleAudio: true

                                            });
                                          }
                                        })
                                      }}
                                    >
                                      {
                                        (OrderDetail?.order_assets?.audios || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      }
                                      <small className="small">
                                        {assetsCount} Audios
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col> */}
                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center"
                                      style={{ background: "#2196F3" }}
                                    >
                                      <AiOutlinePlaySquare
                                        color="white"
                                        size="20"
                                        onClick={() => {

                                          (OrderDetail?.order_assets?.videos || []).map((itm) => {

                                            if (itm.userable_id == item.user.id) {
                                              this.setState({
                                                assestDriverId: item.user.id,
                                                isVisibleVideo: true

                                              });
                                            }
                                          })
                                        }
                                        }
                                      />
                                    </Col>
                                    <Col className="pointer-cursor text-center"
                                      onClick={() => {
                                        (OrderDetail?.order_assets?.videos || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            this.setState({
                                              assestDriverId: item.user.id,
                                              isVisibleVideo: true

                                            });
                                          }
                                        })
                                      }}

                                    >
                                      {
                                        (OrderDetail?.order_assets?.videos || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      }
                                      <small
                                        className="small"
                                      >
                                        {assetsCount} Videos
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center  "
                                      style={{ background: "#E91E63" }}
                                    >
                                      <FaImages
                                        color="white"
                                        size="20"
                                        onClick={() => {

                                          {
                                            (OrderDetail?.order_assets?.images || []).map((itm) => {

                                              if (itm.userable_id == item.user.id) {
                                                if (OrderDetail.meta_asset.images > 0) {
                                                  this.setState({ assestDriverId: item.user.id, isVisible: true });

                                                }
                                              }
                                            })
                                          }
                                        }}
                                      />
                                    </Col>
                                    <Col
                                      className="pointer-cursor text-center"
                                      onClick={() => {

                                        {
                                          (OrderDetail?.order_assets?.images || []).map((itm) => {

                                            if (itm.userable_id == item.user.id) {

                                              if (OrderDetail.meta_asset.images > 0) {

                                                this.setState({ assestDriverId: item.user.id, isVisible: true });
                                              }
                                            }
                                          })
                                        }
                                      }}
                                    >

                                      {
                                        (OrderDetail?.order_assets?.images || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      }

                                      <small className="small">
                                        {assetsCount} Images
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>

                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center"
                                      style={{ background: "#FF9F00" }}
                                    >
                                      <BiNote
                                        color="white"
                                        size="20"
                                        onClick={() =>
                                          this.setState({
                                            documentModal: true,
                                            assestDriverId: item.user.id,
                                          })
                                        }
                                      />
                                    </Col>
                                    <Col
                                      className="pointer-cursor text-center"
                                      onClick={() =>
                                        this.setState({
                                          documentModal: true,
                                          assestDriverId: item.user.id,
                                        })
                                      }
                                    >
                                      {
                                        (OrderDetail?.order_assets?.documents || []).map((itm) => {
                                          // console.log("looooo count", item.userable_id, item.user.id);
                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      }
                                      <small className="small">
                                        {assetsCount} Files
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>

                                {/* Testing Icon For Driver */}
                                {/* <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor"
                                      style={{ background: "#01D1FE" }}
                                    >
                                      <GrTest
                                        color="white"
                                        size="20"
                                        onClick={() =>
                                          this.setState({
                                            documentModal: true,
                                            isTesting: true,
                                          })
                                        }
                                      />
                                    </Col>
                                    <Col
                                      className="pointer-cursor text-center"
                                      onClick={() =>
                                        this.setState({
                                          documentModal: true,
                                          isTesting: true,
                                        })
                                      }
                                    >
                                      <small className="small">
                                        {meta_asset?.test_documents} Testing
                                      </small>
                                    </Col>
                                  </Row>
                                </Col> */}


                                {/* < Col >
                                  <Row style={{ display: "inline" }}
                                    onClick={() => {
                                      this.setState({
                                        distanceModal: true,
                                        isDistance: true,
                                        assestDriverId: item.user.id
                                      });
                                      // }
                                    }}
                                  >
                                    <Col
                                      className="contractor-avatar pointer-cursor"
                                      style={{ background: "#ff9800" }}
                                    >
                                      <img
                                        src={Distance}
                                        width={30}
                                        height={30}
                                      />
                                    </Col>
                                    {console.log(
                                      "meta_asset?.distance",
                                      item?.distance
                                    )}
                                    <Col
                                      className="pointer-cursor text-center"
                                    >
                                      <small className="small">
                                        {getMiles(item?.distance).toFixed(2)}
                                        mi
                                      </small>
                                    </Col>
                                  </Row>
                                </Col> */}

                              </Row>
                            </Col >
                          </Col>
                        </>
                      );
                    })}
                  </Row>
                </Row>
              </OrderNumWrapper >

              <Row justify="end" style={{ marginTop: "1rem" }}>
                {OrderDetail?.logistics_order && (
                  <>
                    {console.log("ORde==>", OrderDetail?.logistics_order?.status)}
                    <Col xl={OrderDetail?.logistics_order?.status == 1 ? 4 : 6}>
                      {(OrderDetail?.logistics_order?.status === 1 || OrderDetail?.logistics_order?.status === 2 || OrderDetail?.logistics_order?.status === 3) && (

                        <Button
                          style={{
                            backgroundColor: "rgb(255, 152, 0)",
                            color: "#fff",
                            // width: "100%",
                          }}
                          onClick={() => {
                            this.setState({
                              isAssignModal: true,
                            });
                            // this.onAssignSubmit();
                            this.props.getLogisticsReq();
                          }}
                        >
                          {OrderDetail?.logistics_order?.status == 1 ? "Assign" : "Add Additional Driver"}
                        </Button>
                      )}

                    </Col>

                    {/* <Col xl={4}>
                      {(OrderDetail?.logistics_order?.status === 1) && (
                        <Button
                          style={{
                            backgroundColor: "rgb(255, 152, 0)",
                            color: "#fff",
                            width: "100%",
                          }}
                          onClick={() => {
                            // dispatchPendingOrder(OrderDetail.id, "", () => {
                            // })

                            this.setState({
                              dispatchOrderModal: true,
                            });
                            // this.onAssignSubmit();
                            // this.props.getLogisticsReq();
                          }}
                        >
                          Dispatch me
                        </Button>
                      )}
                    </Col> */}
                  </>
                )}
                {OrderDetail.status == 1 && (
                  <>
                    <Col xl={4}>
                      <Button
                        style={{
                          backgroundColor: "#31A99E",
                          color: "#fff",
                          width: "100%",
                        }}
                        onClick={() =>
                          this.setState({
                            isOpenReject: true,
                          })
                        }
                      >
                        REJECT
                      </Button>
                    </Col>
                    <Col xl={4}>
                      <Button
                        style={{
                          backgroundColor: "#FF9800",
                          color: "#fff",
                          width: "100%",
                        }}
                        onClick={() =>
                          this.setState({
                            isOpenModal: true,
                          })
                        }
                      >
                        ACCEPT
                      </Button>
                    </Col>
                  </>
                )}
                {OrderDetail.status == 4 && (
                  <Col xl={4}>
                    <Button
                      style={{
                        backgroundColor: "#FF9800",
                        color: "#fff",
                        width: "100%",
                      }}
                      onClick={() => {
                        this.setState({
                          isDispatchModal: true,
                        });
                        this.props.getLogisticsReq();
                        this.props.getLogPartnerReq();
                      }}
                    >
                      Dispatch
                    </Button>
                  </Col>
                )}
              </Row>
            </Col >

            <CustomModal
              visible={this.state.dispatchOrderModal}
              onCancelModal={() =>
                this.setState({
                  dispatchOrderModal: false,
                })
              }
              width={"30%"}
              className="file-modal"
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() => dispatchPendingOrder(OrderDetail.id, "", () => {





                      })}
                    >
                      Dispatch
                    </Button>
                  </Col>
                </Row>,
              ]}
            >


              {OrderDetail?.logistics_order?.status == 1 &&
                <Row justify="center">
                  <Col span={24}>
                    <h5
                      className="text-center st-primary"
                      style={{ paddingBottom: "10px" }}
                    >
                      Dispatch Order
                    </h5>
                  </Col>

                  {/* <Row>
                    <Col span={24} className="text-center">


                      <span style={{ marginRight: "5px" }}>Assign Multiple Drivers</span>
                      <Switch checked={this.state.subDriverToggle} onClick={(checked) => checked ? this.setState({ subDriverToggle: true }) : this.setState({ subDriverToggle: false, selectedSubDriver: [], customError: { subdriver_id_Error: "" } })} />

                    </Col>

                  </Row> */}

                  {/* {OrderDetail?.logistics_order?.status == 1 &&
                    <Col
                      xl={20}
                      className="select-categories"
                      style={{ height: "50%", marginBottom: 10 }}
                    >

                      <Select
                        className="custom ant-select-selector"
                        style={{ height: "100%" }}
                        size="large"
                        disabled={OrderDetail?.logistics_order?.status === 2 || OrderDetail?.logistics_order?.status == 3}
                        placeholder="Select Lead Driver"
                        onChange={(e) => {
                          const driverN = logistics.find((item) => {
                            return item.id == e;
                          });
                          const filterOptionSubDriver = logistics.filter((item) => {
                            return item.id !== e;
                          });

                          this.setState({
                            driver_id: e,
                            customError: {
                              ...customError,
                              driver_id_Error: "",
                            },
                            optionSubdriver: filterOptionSubDriver,
                            driver_name: `${driverN?.user?.first_name} ${driverN?.user?.last_name}`,
                            selectedSubDriver: []
                          });
                        }}
                        value={this.state.driver_name}
                      >
                        {logistics.map((item) => {
                          return (
                            <Option value={item.id}>
                              <Row>
                                <Col span={24}>
                                  <Row align="middle">
                                    <Col span={6}>
                                      <img
                                        src={item?.user?.image?.original}
                                        height={"50"}
                                        width={"50"}
                                        style={{ borderRadius: "50%" }}
                                      />
                                    </Col>
                                    <Col span={12} className="text-left">
                                      <span>
                                        {`${item?.user?.first_name} ${item?.user?.last_name}`}
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Option>
                          );
                        })}
                      </Select>
                      <Row justify="start">
                        <Col span={22}>
                          <span className="danger-color text-left">
                            {customError.driver_id_Error &&
                              customError.driver_id_Error}
                          </span>
                        </Col>
                      </Row>
                    </Col>

                  } */}


                  {/* <Col
                    xl={20}
                    className="select-categories"
                    style={{ height: "50%", marginBottom: 10, marginTop: 10 }}
                  >
                    <Select
                      mode="multiple"
                      className="custom ant-select-selector"
                      style={{ height: "100%" }}
                      size="large"
                      placeholder="Multiple Drivers"
                      allowClear
                      disabled={!this.state.subDriverToggle}
                      value={this.state.selectedSubDriver}
                      onChange={(val) => this.setState({
                        selectedSubDriver: val,
                        customError: {
                          ...customError,
                          subdriver_id_Error: "",
                        },
                      })}
                    // options={options}
                    >
                      {this.state.optionSubdriver?.map((item) => {
                        return (
                          <Option value={item.id}>
                            <Row>
                              <Col span={24}>
                                <Row align="middle">
                                  <Col span={12} className="text-left">
                                    <span>
                                      {`${item?.user?.first_name} ${item?.user?.last_name}`}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Option>
                        );
                      })}





                    </Select>
                    <Row justify="start">
                      <Col span={22}>
                        <span className="danger-color text-left">
                          {customError.subdriver_id_Error &&
                            customError.subdriver_id_Error}
                        </span>
                      </Col>
                    </Row>
                  </Col> */}


                  {OrderDetail?.logistics_order?.status == 1 &&
                    <Col
                      span={20}
                      className="text-start"
                    // style={{ paddingTop: "10px" }}
                    >
                      <Row justify="center">
                        <Col span={24} className="text-start">
                          <RadioWrapper
                            onChange={(e) =>
                              this.setState({
                                driver_id: e.target.value,
                                radioValue: "",
                              })
                            }
                            checked={!this.state.radioValue}
                            value="driver_id"
                          />
                          <span>Dispatch Immediately</span>
                        </Col>
                      </Row>
                    </Col>
                  }
                  {OrderDetail?.logistics_order?.status == 1 &&
                    <Col
                      span={20}
                      style={{ paddingTop: "10px", paddingBottom: "10px" }}
                    >
                      <Row justify="center">
                        <Col span={24}>
                          <Row gutter={[10, 10]}>
                            <Col span={10}>
                              <RadioWrapper
                                checked={this.state.radioValue === "start_time"}
                                onChange={(e) =>
                                  this.setState({
                                    start_time: e.target.value,
                                    radioValue: "start_time",
                                  })
                                }
                                value="start_time"
                              />
                              <span>Select Time</span>
                            </Col>
                            <Col span={5}>
                              <TextInput
                                type="text"
                                onChangeStyle={{
                                  width: "100%",
                                  height: "40px",
                                  marginTop: "-20px",
                                }}
                                onChange={(e) =>
                                  this.setState({
                                    setHours: e.target.value,
                                    ...customError,
                                    customError: {
                                      setHours_Error: "",
                                    },
                                  })
                                }
                                disabled={!this.state.radioValue}
                                value={setHours}
                                maxLength="2"
                              />
                            </Col>
                            <Col span={1}>:</Col>
                            <Col span={5}>
                              <TextInput
                                type="text"
                                onChangeStyle={{
                                  width: "100%",
                                  height: "40px",
                                  marginTop: "-20px",
                                }}
                                onChange={(e) =>
                                  this.setState({
                                    setMin: e.target.value,
                                    customError: {
                                      ...customError,
                                      setHours_Error: "",
                                    },
                                  })
                                }
                                value={setMin}
                                disabled={!this.state.radioValue}
                                maxLength="2"
                              />
                            </Col>
                            <Col span={3}>
                              <span
                                className="am-circle am-pm-circle"
                                style={{
                                  marginTop: "-5px",
                                }}
                              >
                                {OrderDetail?.preferred_delivery_period}
                              </span>
                            </Col>
                          </Row>
                          <Row justify="start">
                            <Col>
                              <span className="danger-color text-left">
                                {customError.setHours_Error &&
                                  customError.setHours_Error}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  }
                  <Col span={20}>
                    <Divider />
                  </Col>

                  <ul id="scroller">
                    {(this.props.log_partner || []).map((item) => {
                      return (
                        <li>
                          <span span={4}>
                            <img
                              src={item.users?.[0]?.image?.original}
                              height={"50"}
                              width={"50"}
                              style={{ borderRadius: "50%" }}
                            />
                          </span>
                          <span span={24}>
                            <p className="three-dot">
                              {item.users?.[0]?.first_name}{" "}
                              {item.users?.[0]?.last_name}
                            </p>{" "}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </Row>
              }

            </CustomModal>





            {/* individual testdocument modal */}
            {/* <CustomModal
              visible={this.state.testFileDocument}
              onCancelModal={() =>
                this.setState({
                  testFileDocument: false,
                  isTesting: false,
                  assestDriverId: ""
                })
              }
              width={800}
              className="file-modal"
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() => inputRef.click()}
                    >
                      Upload
                    </Button>
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h3 className="text-left" style={{ color: "grey" }}>
                    {"TEST FILES"}
                  </h3>
                </Col>

                {
                  (OrderDetail?.order_assets?.test_documents || []
                  ).map((item) => {
                    if (item.userable_id == this.state.assestDriverId) {
                      return (
                        <FileView
                          item={item}
                          orderId={OrderDetail.id}
                          {...this.props}
                          isTesting={this.state.isTesting}
                        />

                      );
                    }
                  })}

                {OrderDetail?.order_assets?.test_documents?.length === 0 && (
                  <Col
                    span={12}
                    style={{
                      textAlign: "center",
                      margin: "25%",
                      color: "grey",
                    }}
                  >
                    <span>Nothing to show right now</span>
                  </Col>
                )}
              </Row>
            </CustomModal> */}


            {/* individual document modal */}
            {/* <CustomModal
              visible={this.state.fileDocument}
              onCancelModal={() =>
                this.setState({
                  fileDocument: false,
                  isTesting: false,
                })
              }
              width={800}
              className="file-modal"
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() => inputRef.click()}
                    >
                      Upload
                    </Button>
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h3 className="text-left" style={{ color: "grey" }}>
                    {"FILES"}
                  </h3>
                </Col>

                {(OrderDetail?.order_assets?.documents || []
                ).map((item) => {
                  if (item.userable_id == this.state.assestDriverId) {
                    return (
                      <FileView
                        item={item}
                        orderId={OrderDetail.id}
                        {...this.props}
                        isTesting={this.state.isTesting}
                      />

                    );
                  }
                })}
                {OrderDetail?.order_assets?.documents?.length === 0 && (
                  <Col
                    span={12}
                    style={{
                      textAlign: "center",
                      margin: "25%",
                      color: "grey",
                    }}
                  >
                    <span>Nothing to show right now</span>
                  </Col>
                )}
              </Row>
            </CustomModal> */}



            {/* logistic FileModal */}
            <CustomModal
              visible={this.state.isOpenLogisticsFileModal}
              onCancelModal={() =>
                this.setState({
                  isOpenLogisticsFileModal: false,
                  isTesting: false,
                })
              }
              width={800}
              className="file-modal"
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    {OrderDetail?.status == 7 ? "" :

                      <Button
                        style={{
                          backgroundColor: "#ff9800",
                          color: "#fff",
                          width: "30%",
                          border: "none",
                        }}
                        onClick={() => inputRef.click()}
                      >
                        Upload
                      </Button>
                    }
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h3 className="text-left" style={{ color: "grey" }}>
                    {this.state.isTesting ? "TEST" : "FILES"}
                  </h3>
                </Col>
                {(this.state.isTesting
                  ? OrderDetail?.order_assets?.test_documents
                  : orderDetailDocument || []
                ).map((item) => {
                  return (
                    <FileView
                      item={item}
                      orderId={OrderDetail.id}
                      {...this.props}
                      isTesting={this.state.isTesting}
                    />
                  );
                })}
                {OrderDetail?.order_assets?.documents?.length === 0 &&
                  !this.state.isTesting && (
                    <Col
                      span={12}
                      style={{
                        textAlign: "center",
                        margin: "25%",
                        color: "grey",
                      }}
                    >
                      <span>Nothing to show right now</span>
                    </Col>
                  )}
                {OrderDetail?.order_assets?.test_documents?.length === 0 &&
                  !!this.state.isTesting && (
                    <Col
                      span={12}
                      style={{
                        textAlign: "center",
                        margin: "25%",
                        color: "grey",
                      }}
                    >
                      <span>Nothing to show right now</span>
                    </Col>
                  )}
              </Row>
            </CustomModal>


            {/* logistic TestModal */}
            <CustomModal
              visible={this.state.isOpenLogisticsTestsModal}
              onCancelModal={() =>
                this.setState({
                  isOpenLogisticsTestsModal: false,
                  isTesting: false,
                })
              }
              width={800}
              className="file-modal"
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >

                    {OrderDetail?.status == 7 ? "" :

                      <Button
                        style={{
                          backgroundColor: "#ff9800",
                          color: "#fff",
                          width: "30%",
                          border: "none",
                        }}
                        onClick={() => inputRef.click()}
                      >
                        Upload
                      </Button>
                    }

                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h3 className="text-left" style={{ color: "grey" }}>
                    {this.state.isTesting ? "TEST" : "FILES"}
                  </h3>
                </Col>
                {(this.state.isTesting
                  ? orderDetailTestDocument
                  : OrderDetail?.order_assets?.documents || []
                ).map((item) => {
                  return (
                    <FileView
                      item={item}
                      orderId={OrderDetail.id}
                      {...this.props}
                      isTesting={this.state.isTesting}
                    />
                  );
                })}
                {OrderDetail?.order_assets?.documents?.length === 0 &&
                  !this.state.isTesting && (
                    <Col
                      span={12}
                      style={{
                        textAlign: "center",
                        margin: "25%",
                        color: "grey",
                      }}
                    >
                      <span>Nothing to show right now</span>
                    </Col>
                  )}
                {OrderDetail?.order_assets?.test_documents?.length === 0 &&
                  !!this.state.isTesting && (
                    <Col
                      span={12}
                      style={{
                        textAlign: "center",
                        margin: "25%",
                        color: "grey",
                      }}
                    >
                      <span>Nothing to show right now</span>
                    </Col>
                  )}
              </Row>
            </CustomModal>


            {/* logistics Notemodal */}
            {/* <CustomModal
              visible={this.state.isOpenLogisticsNotesModal}
              onCancelModal={() =>
                this.setState({
                  isOpenLogisticsNotesModal: false,
                  assestDriverId: "",
                  noteShowOnModal: ""
                })
              }
              footer={[

              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h6
                    style={{ color: "#09c1b2", fontSize: "1rem" }}
                    className="text-left"
                  >
                    NOTES
                  </h6>
                </Col>
                <Col
                  span={24}
                  className="d-flex text-left"
                  style={{ width: "100%", marginTop: '1rem' }}
                >
                  <span className="text-left">{OrderDetail?.note}</span>
                </Col>
              </Row>
            </CustomModal> */}




            <CustomModal
              visible={this.state.documentModal}
              onCancelModal={() =>
                this.setState({
                  documentModal: false,
                  isTesting: false,
                })
              }
              width={800}
              className="file-modal"
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    {/* <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() => inputRef.click()}
                    >
                      Upload
                    </Button> */}
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h3 className="text-left" style={{ color: "grey" }}>
                    {this.state.isTesting ? "TEST" : "FILES"}
                  </h3>
                </Col>
                {/* {isUploadDoc ? (
                  <img src={LoaderGif} height="60" width={60} />
                ) : */}
                {
                  (this.state.isTesting
                    ? OrderDetail?.order_assets?.test_documents
                    : OrderDetail?.order_assets?.documents || []
                  ).map((item) => {
                    if (item.userable_id == this.state.assestDriverId) {
                      return (
                        <FileView
                          item={item}
                          orderId={OrderDetail.id}
                          {...this.props}
                          isTesting={this.state.isTesting}
                        />
                      );
                    }
                  })
                }
                {OrderDetail?.order_assets?.documents?.length === 0 &&
                  !this.state.isTesting && (
                    <Col
                      span={12}
                      style={{
                        textAlign: "center",
                        margin: "25%",
                        color: "grey",
                      }}
                    >
                      <span>Nothing to show right now</span>
                    </Col>
                  )}
                {OrderDetail?.order_assets?.test_documents?.length === 0 &&
                  !!this.state.isTesting && (
                    <Col
                      span={12}
                      style={{
                        textAlign: "center",
                        margin: "25%",
                        color: "grey",
                      }}
                    >
                      <span>Nothing to show right now</span>
                    </Col>
                  )}
              </Row>
            </CustomModal>

            <CustomModal
              visible={this.state.isDispatchModal}
              onCancelModal={() =>
                this.setState({
                  isDispatchModal: false,
                })
              }
              width={600}
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#31A99E",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() => {
                        approvedOrder(
                          OrderDetail.id,
                          () => {
                            this.onCancelModal();
                            this.props.history.push("/dashboard");
                          },
                          "dispatch",
                          this.state.logValue
                        );
                      }}
                    >
                      Dispatch
                    </Button>


                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h2 className="text-center st-primary">Dispatch</h2>
                </Col>
                <Col
                  xl={22}
                  className="select-categories"
                  style={{ height: "50%" }}
                >
                  <Select
                    className="custom ant-select-selector"
                    style={{ height: "100%" }}
                    size="large"
                    placeholder="Select logistics partner"
                    name="basemix_category_id"
                    onChange={(e) =>
                      this.setState({
                        logValue: e,
                      })
                    }
                  // onSelect={() =>
                  //   this.setState({
                  //     isSelect: true,
                  //   })
                  // }
                  // open={!this.state.isSelect}
                  // onFocus={() =>
                  //   this.setState({
                  //     isSelect: false,
                  //   })
                  // }
                  >
                    {logistics?.map((item) => {
                      return (
                        <Option value={item.id}>
                          <div
                            className="text-left"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <img
                              src={item.users?.[0]?.image?.original}
                              height={"50"}
                              width={"50"}
                              style={{ borderRadius: "50%" }}
                            />

                            {item?.business_name}

                            <AiFillStar
                              color={item.favourite ? "#F9A01B" : "grey"}
                              size="25"
                              onClick={() => this.props.markAsFav(item.id)}
                            />
                          </div>

                          {/* <Row justify="space-between">
                        <Col span={20}>
                          <Row justify="space-between">
                            <Col span={2}>
                              <img
                                src={item.users?.[0]?.image?.original}
                                height={"50"}
                                width={"50"}
                                style={{ borderRadius: "50%" }}
                              />
                            </Col>
                            <Col span={12}>
                              <p className="text-left">{item?.business_name}</p>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={4}>
                          <AiFillStar
                            color={item.favourite ? "#F9A01B" : "grey"}
                            size="25"
                            onClick={() => this.props.markAsFav(item.id)}
                          />
                        </Col>
                      </Row> */}
                        </Option>
                      );
                    })}
                  </Select>
                </Col>
                <ul id="scroller">
                  {(this.props.log_partner || []).map((item) => {
                    return (
                      <li>
                        <span span={4}>
                          <img
                            src={item.users?.[0]?.image?.original}
                            height={"50"}
                            width={"50"}
                            style={{ borderRadius: "50%" }}
                          />
                        </span>
                        <span span={24}>
                          <p className="three-dot">
                            {item.users?.[0]?.first_name}{" "}
                            {item.users?.[0]?.last_name}
                          </p>{" "}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </Row>
            </CustomModal>

            <CustomModal
              visible={this.state.isAssignModal}
              onCancelModal={() =>
                this.setState({
                  isAssignModal: false,
                })
              }
              destroyOnClose={() => this.setState({
                setHours: "",
                setMin: "",
                driver_id: "",
                driver_name: null,
                customError: "",
                selectedSubDriver: [],
                subDriverToggle: false,
                optionSubdriver: []
              })}
              width={"30%"}
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#9e9e9e",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() => {
                        this.onCancelModal();
                        this.setState({
                          setHours: "",
                          setMin: "",
                          driver_id: "",
                          customError: "",
                          selectedSubDriver: [],
                          subDriverToggle: false,
                          driver_name: null,
                          optionSubdriver: []

                        });
                      }}
                    >
                      Cancel
                    </Button>
                    {this.props.isLoader ? (
                      <img src={LoaderGif} height={"60"} width={"60"} />
                    ) : (
                      <>
                        {OrderDetail.logistics_order.status == 1 && <Button
                          style={{
                            backgroundColor: "#31A99E",
                            color: "#fff",
                            width: "30%",
                            border: "none",
                          }}
                          onClick={() => {
                            this.onSubmit();
                          }}
                        >
                          Dispatch
                        </Button>
                        }
                        {OrderDetail.logistics_order.status == 2 || OrderDetail.logistics_order.status == 3 ?
                          < Button
                            style={{
                              backgroundColor: "#31A99E",
                              color: "#fff",
                              width: "33%",
                              border: "none",
                            }}
                            onClick={() => {
                              this.onSubmit();
                            }}
                          >
                            Assign Driver
                          </Button>

                          : ""
                        }

                      </>

                    )}
                  </Col>
                </Row>,
              ]}
            >
              {OrderDetail?.logistics_order?.status == 1 &&
                <Row justify="center">
                  <Col span={24}>
                    <h5
                      className="text-center st-primary"
                      style={{ paddingBottom: "10px" }}
                    >
                      Assign Order
                    </h5>
                  </Col>
                  {/* <Col span={24} className="text-left">
                  <p style={{ marginLeft:25,fontWeight:"bold" }}>
                    Select drivers to dispatch this order
                  </p>
                </Col>
                <Col 
                  xl={20}
                  className="select-categories"
                  style={{ height: "40%",marginBottom:10  }}
                >
                    {[1,2,3,4].map((item, index) => (
                      <div className="chip">
                        {"Arif"}{" "}
                        <span
                          className="pointer-cursor"
                          // onClick={() => {
                          //   download_report.recipients.splice(index, 1);
                          //   this.setState({
                          //     download_report,
                          //   });
                          // }}
                        >
                          x
                        </span>
                      </div>
                    ))}
                  <Select
                    className="custom ant-select-selector"
                    // mode="multiple"
                    // style={{ height: "80%" }}
                    size="large"
                    placeholder="Select Driver"
                    onChange={(e) => {
                      const driverN = logistics.find((item) => {
                        return item.id == e;
                      });
                      this.setState({
                        driver_id: e,
                        customError: {
                          ...customError,
                          driver_id_Error: "",
                        },
                        driver_name: `${driverN?.user?.first_name} ${driverN?.user?.last_name}`,
                      });
                    }}
                    value={this.state.driver_name}
                  >
                    {logistics.map((item) => {
                      return (
                        <Option value={item.id}>
                          <Row>
                            <Col span={24}>
                              <Row align="middle">
                                <Col span={6}>
                                  <img
                                    src={item?.user?.image?.original}
                                    height={"50"}
                                    width={"50"}
                                    style={{ borderRadius: "50%" }}
                                  />
                                </Col>
                                <Col span={12} className="text-left">
                                  <span>
                                    {`${item?.user?.first_name} ${item?.user?.last_name}`}
                                  </span>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Option>
                      );
                    })}
                  </Select>
                  <Row justify="start">
                    <Col span={22}>
                      <span className="danger-color text-left">
                        {customError.driver_id_Error &&
                          customError.driver_id_Error}
                      </span>
                    </Col>
                  </Row>
                </Col> */}
                  <Row>
                    <Col span={24} className="text-center">


                      <span style={{ marginRight: "5px" }}>Assign Multiple Drivers</span>
                      <Switch checked={this.state.subDriverToggle} onClick={(checked) => checked ? this.setState({ subDriverToggle: true }) : this.setState({ subDriverToggle: false, selectedSubDriver: [], customError: { subdriver_id_Error: "" } })} />

                    </Col>

                  </Row>

                  {OrderDetail?.logistics_order?.status == 1 &&
                    <Col
                      xl={20}
                      className="select-categories"
                      style={{ height: "50%", marginBottom: 10 }}
                    >

                      <Select
                        className="custom ant-select-selector"
                        style={{ height: "100%" }}
                        size="large"
                        disabled={OrderDetail?.logistics_order?.status === 2 || OrderDetail?.logistics_order?.status == 3}
                        placeholder="Select Lead Driver"
                        onChange={(e) => {
                          const driverN = logistics.find((item) => {
                            return item.id == e;
                          });
                          const filterOptionSubDriver = logistics.filter((item) => {
                            return item.id !== e;
                          });

                          this.setState({
                            driver_id: e,
                            customError: {
                              ...customError,
                              driver_id_Error: "",
                            },
                            optionSubdriver: filterOptionSubDriver,
                            driver_name: `${driverN?.user?.first_name} ${driverN?.user?.last_name}`,
                            selectedSubDriver: []
                          });
                        }}
                        value={this.state.driver_name}
                      >
                        {logistics.map((item) => {
                          return (
                            <Option value={item.id}>
                              <Row>
                                <Col span={24}>
                                  <Row align="middle">
                                    <Col span={6}>
                                      <img
                                        src={item?.user?.image?.original}
                                        height={"50"}
                                        width={"50"}
                                        style={{ borderRadius: "50%" }}
                                      />
                                    </Col>
                                    <Col span={12} className="text-left">
                                      <span>
                                        {`${item?.user?.first_name} ${item?.user?.last_name}`}
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Option>
                          );
                        })}
                      </Select>
                      <Row justify="start">
                        <Col span={22}>
                          <span className="danger-color text-left">
                            {customError.driver_id_Error &&
                              customError.driver_id_Error}
                          </span>
                        </Col>
                      </Row>
                    </Col>

                  }

                  <Col
                    xl={20}
                    className="select-categories"
                    style={{ height: "50%", marginBottom: 10, marginTop: 10 }}
                  >
                    <Select
                      mode="multiple"
                      className="custom ant-select-selector"
                      style={{ height: "100%" }}
                      size="large"
                      placeholder="Multiple Drivers"
                      allowClear
                      disabled={!this.state.subDriverToggle}
                      value={this.state.selectedSubDriver}
                      onChange={(val) => this.setState({
                        selectedSubDriver: val,
                        customError: {
                          ...customError,
                          subdriver_id_Error: "",
                        },
                      })}
                    // options={options}
                    >
                      {this.state.optionSubdriver?.map((item) => {
                        return (
                          <Option value={item.id}>
                            <Row>
                              <Col span={24}>
                                <Row align="middle">
                                  {/* <Col span={6}>
                                  <img
                                    src={item?.user?.image?.original}
                                    height={"50"}
                                    width={"50"}
                                    style={{ borderRadius: "50%" }}
                                  />
                                </Col> */}
                                  <Col span={12} className="text-left">
                                    <span>
                                      {`${item?.user?.first_name} ${item?.user?.last_name}`}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Option>
                        );
                      })}





                    </Select>
                    <Row justify="start">
                      <Col span={22}>
                        <span className="danger-color text-left">
                          {customError.subdriver_id_Error &&
                            customError.subdriver_id_Error}
                        </span>
                      </Col>
                    </Row>
                  </Col>

                  {/* single paver toggle */}
                  <Row>
                    <Col span={24} className="text-center">


                      <span style={{ marginRight: "5px", marginTop: "5px" }}>Assign Multiple Pavers</span>
                      <Switch checked={this.state.subPaverToggle} onClick={(checked) => checked ? this.setState({ subPaverToggle: true }) : this.setState({ subPaverToggle: false, selectedSubPaver: [], customError: { subPaver_id_Error: "" } })} />

                    </Col>

                  </Row>

                  {/* single paver */}
                  {OrderDetail?.logistics_order?.status == 1 &&
                    <Col
                      xl={20}
                      className="select-categories"
                      style={{ height: "50%", marginBottom: 10 }}
                    >

                      <Select
                        className="custom ant-select-selector"
                        style={{ height: "100%" }}
                        size="large"
                        disabled={OrderDetail?.logistics_order?.status === 2 || OrderDetail?.logistics_order?.status == 3}
                        placeholder="Select Lead Paver"
                        onChange={(e) => {
                          const paverN = pavers?.find((item) => {
                            return item.id == e;
                          });
                          const filterOptionSubPaver = pavers?.filter((item) => {
                            return item.id !== e;
                          });

                          this.setState({
                            paver_id: e,
                            customError: {
                              ...customError,
                              paver_id_Error: "",
                            },
                            optionSubPaver: filterOptionSubPaver,
                            paver_name: `${paverN?.user?.first_name} ${paverN?.user?.last_name}`,
                            selectedSubPaver: [],
                            isPaverSelected: true
                          });
                        }}
                        value={this.state.paver_name}
                      >
                        {pavers?.map((item) => {
                          return (
                            <Option value={item.id}>
                              <Row>
                                <Col span={24}>
                                  <Row align="middle">
                                    <Col span={6}>
                                      <img
                                        src={item?.user?.image?.original}
                                        height={"50"}
                                        width={"50"}
                                        style={{ borderRadius: "50%" }}
                                      />
                                    </Col>
                                    <Col span={12} className="text-left">
                                      <span>
                                        {`${item?.user?.first_name} ${item?.user?.last_name}`}
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Option>
                          );
                        })}
                      </Select>
                      {/* <Row justify="start">
                        <Col span={22}>
                          <span className="danger-color text-left">
                            {customError.paver_id_Error &&
                              customError.paver_id_Error}
                          </span>
                        </Col>
                      </Row> */}
                    </Col>

                  }
                  {/* multiple pavers */}
                  <Col
                    xl={20}
                    className="select-categories"
                    style={{ height: "50%", marginBottom: 10, marginTop: 10 }}
                  >
                    <Select
                      mode="multiple"
                      className="custom ant-select-selector"
                      style={{ height: "100%" }}
                      size="large"
                      placeholder="Multiple Pavers"
                      allowClear
                      disabled={!this.state.subPaverToggle}
                      value={this.state.selectedSubPaver}
                      onChange={(val) => this.setState({
                        selectedSubPaver: val,
                        customError: {
                          ...customError,
                          subPaver_id_Error: "",
                        },
                      })}
                    >
                      {this.state.optionSubPaver?.map((item) => {
                        return (
                          <Option value={item.id}>
                            <Row>
                              <Col span={24}>
                                <Row align="middle">

                                  <Col span={12} className="text-left">
                                    <span>
                                      {`${item?.user?.first_name} ${item?.user?.last_name}`}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Option>
                        );
                      })}





                    </Select>
                    {/* <Row justify="start">
                      <Col span={22}>
                        <span className="danger-color text-left">
                          {customError.subPaver_id_Error &&
                            customError.subPaver_id_Error}
                        </span>
                      </Col>
                    </Row> */}
                  </Col>

                  {/* shipping address, Latitude, Longitude, Radius Fields */}
                  {/* <Col
                    xl={20}
                    className="select-categories"
                    style={{ height: "50%", marginBottom: 10, marginTop: 10 }}>

                    <Row justify="space-between" gutter={[5, 30]}>
                      <Col span={24} className="select-categories">
                        <span
                          style={{
                            color: "#26a69a",
                            marginRight: "10px",
                          }}
                        >
                          Shipping Address 
                        </span>
                        <PlacesInput
                          className="userSelect"
                          value={`${this.state.shippingAddress}`}
                          onChange={(e) =>
                            this.setState({
                              shippingAddress: e.target.value,
                            })
                          }
                          onSetValue={(val) => {
                            console.log("stateVal==>", val);
                            this.setState({
                              shippingAddress: val.formatted_address,
                              latitude: val.geometry.location.lat(),
                              longitude: val.geometry.location.lng(),
                              customError: {
                                ...customError,
                                latitude_Error: "",
                                longitude_Error: "",
                              },
                            });
                          }}
                          maxLength={50}

                        />
                        
                      </Col>
                      <Col xl={24}>
                        <TextInput label="Latitude" name="latitude" required={isPaverSelected}
                          value={this.state.latitude} 
                          onChange={(e)=>{
                            this.setState({
                              latitude: e.target.value,
                              customError: {
                                ...customError,
                                latitude_Error: "",
                              }
                            })
                          }} 
                          />
                        <Row justify="end">
                          <Col span={24} className="">
                            <span className="danger-color">
                              {customError?.latitude_Error && this.state.customError?.latitude_Error}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={24}>
                      <TextInput label="Longitude" name="longitude" required={isPaverSelected}
                        value={this.state.longitude} 
                        onChange={(e)=>{
                          this.setState({
                            longitude: e.target.value,
                            customError: {
                              ...customError,
                              longitude_Error: "",
                            }
                          })
                        }} 
                        />
                        <Row justify="end">
                          <Col span={24} className="">
                            <span className="danger-color">
                              {customError?.longitude_Error && customError?.longitude_Error}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={24}>
                      <TextInput label="Radius" name="radius" required={isPaverSelected}
                        value={this.state.radius} 
                        onChange={(e)=>{
                          this.setState({
                            radius: e.target.value,
                            customError: {
                              ...customError,
                              radius_Error: "",
                            }
                          })
                        }} 
                        />
                        <Row justify="end">
                          <Col span={24} className="">
                            <span className="danger-color">
                              {customError?.radius_Error && customError?.radius_Error}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                  </Col> */}


                  {OrderDetail?.logistics_order?.status == 1 &&
                    <Col
                      span={20}
                      className="text-start"
                    // style={{ paddingTop: "10px" }}
                    >
                      <Row justify="center">
                        <Col span={24} className="text-start">
                          <RadioWrapper
                            onChange={(e) =>
                              this.setState({
                                driver_id: e.target.value,
                                radioValue: "",
                              })
                            }
                            checked={!this.state.radioValue}
                            value="driver_id"
                          />
                          <span>Dispatch Immediately</span>
                        </Col>
                      </Row>
                    </Col>
                  }
                  {OrderDetail?.logistics_order?.status == 1 &&
                    <Col
                      span={20}
                      style={{ paddingTop: "10px", paddingBottom: "10px" }}
                    >
                      <Row justify="center">
                        <Col span={24}>
                          <Row gutter={[10, 10]}>
                            <Col span={10}>
                              <RadioWrapper
                                checked={this.state.radioValue === "start_time"}
                                onChange={(e) =>
                                  this.setState({
                                    start_time: e.target.value,
                                    radioValue: "start_time",
                                  })
                                }
                                value="start_time"
                              />
                              <span>Select Time</span>
                            </Col>
                            <Col span={5}>
                              <TextInput
                                type="text"
                                onChangeStyle={{
                                  width: "100%",
                                  height: "40px",
                                  marginTop: "-20px",
                                }}
                                onChange={(e) =>
                                  this.setState({
                                    setHours: e.target.value,
                                    ...customError,
                                    customError: {
                                      setHours_Error: "",
                                    },
                                  })
                                }
                                disabled={!this.state.radioValue}
                                value={setHours}
                                maxLength="2"
                              />
                            </Col>
                            <Col span={1}>:</Col>
                            <Col span={5}>
                              <TextInput
                                type="text"
                                onChangeStyle={{
                                  width: "100%",
                                  height: "40px",
                                  marginTop: "-20px",
                                }}
                                onChange={(e) =>
                                  this.setState({
                                    setMin: e.target.value,
                                    customError: {
                                      ...customError,
                                      setHours_Error: "",
                                    },
                                  })
                                }
                                value={setMin}
                                disabled={!this.state.radioValue}
                                maxLength="2"
                              />
                            </Col>
                            <Col span={3}>
                              <span
                                className="am-circle am-pm-circle"
                                style={{
                                  marginTop: "-5px",
                                }}
                              >
                                {OrderDetail?.preferred_delivery_period}
                              </span>
                            </Col>
                          </Row>
                          <Row justify="start">
                            <Col>
                              <span className="danger-color text-left">
                                {customError.setHours_Error &&
                                  customError.setHours_Error}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  }
                  <Col span={20}>
                    <Divider />
                  </Col>

                  <ul id="scroller">
                    {(this.props.log_partner || []).map((item) => {
                      return (
                        <li>
                          <span span={4}>
                            <img
                              src={item.users?.[0]?.image?.original}
                              height={"50"}
                              width={"50"}
                              style={{ borderRadius: "50%" }}
                            />
                          </span>
                          <span span={24}>
                            <p className="three-dot">
                              {item.users?.[0]?.first_name}{" "}
                              {item.users?.[0]?.last_name}
                            </p>{" "}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </Row>
              }

              {/* condition modal for assign driver on dispatch and pending */}
              {OrderDetail?.logistics_order?.status == 2 || OrderDetail?.logistics_order?.status == 3 ?
                <Row justify="center">
                  <Col span={24}>
                    <h5
                      className="text-center st-primary"
                      style={{ paddingBottom: "10px" }}
                    >
                      Assign Order
                    </h5>
                  </Col>

                  <Row>
                    <Col span={24} className="text-center">
                      {OrderDetail?.logistics_order?.status == 3 && <span style={{ marginRight: "5px" }}>Assign More Drivers</span>}
                      {OrderDetail?.logistics_order?.status == 2 && <span style={{ marginRight: "5px" }}>Assign More Drivers</span>}
                      {/* <span style={{ marginRight: "5px" }}>Assign Multiple Drivers</span> */}
                      <Switch checked={this.state.subDriverToggle} onClick={(checked) => checked ? this.setState({ subDriverToggle: true }) : this.setState({ subDriverToggle: false, selectedSubDriver: [], customError: { subdriver_id_Error: "" } })} />

                    </Col>
                  </Row>

                  {/* {OrderDetail?.logistics_order?.status == 2 &&
                    <Col
                      xl={20}
                      className="select-categories"
                      style={{ height: "50%", marginBottom: 10 }}
                    >
                      <Select
                        className="custom ant-select-selector"
                        style={{ height: "100%" }}
                        size="large"
                        // disabled={}
                        placeholder="Select Lead Driver"
                        onChange={(e) => {
                          const driverN = leadAlreadyAssigned.find((item) => {
                            return item.id == e;
                          });
                          const filterOptionSubDriver = logistics.filter((item) => {
                            return item.id !== e;
                          });

                          this.setState({
                            driver_id: e,
                            customError: {
                              ...customError,
                              driver_id_Error: "",
                            },
                            optionSubdriver: filterOptionSubDriver,
                            driver_name: `${driverN?.user?.first_name} ${driverN?.user?.last_name}`,
                            selectedSubDriver: []
                          });
                        }}
                        value={this.state.driver_name}
                      >
                        {leadAlreadyAssigned?.map((item) => {
                          return (
                            <Option value={item.id}>
                              <Row>
                                <Col span={24}>
                                  <Row align="middle">
                                    <Col span={6}>
                                      <img
                                        src={item?.user?.image?.original}
                                        height={"50"}
                                        width={"50"}
                                        style={{ borderRadius: "50%" }}
                                      />
                                    </Col>
                                    <Col span={12} className="text-left">
                                      <span>
                                        {`${item?.user?.first_name} ${item?.user?.last_name}`}
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Option>
                          );
                        })}
                      </Select>
                      <Row justify="start">
                        <Col span={22}>
                          <span className="danger-color text-left">
                            {customError.driver_id_Error &&
                              customError.driver_id_Error}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  } */}

                  <Col
                    xl={20}
                    className="select-categories"
                    style={{ height: "50%", marginBottom: 10, marginTop: 10 }}
                  >
                    <Select
                      mode="multiple"
                      className="custom ant-select-selector"
                      style={{ height: "100%" }}
                      size="large"
                      placeholder="Multiple Drivers"
                      allowClear
                      disabled={!this.state.subDriverToggle}
                      value={this.state.selectedSubDriver}
                      onChange={(val) => this.setState({
                        selectedSubDriver: val,
                        customError: {
                          ...customError,
                          subdriver_id_Error: "",
                        },
                      })}
                    // options={options}
                    >

                      {result?.map((item) => {
                        return (
                          <Option value={item.id}>
                            <Row>
                              <Col span={24}>
                                <Row align="middle">
                                  {/* <Col span={6}>
                                  <img
                                    src={item?.user?.image?.original}
                                    height={"50"}
                                    width={"50"}
                                    style={{ borderRadius: "50%" }}
                                  />
                                </Col> */}
                                  <Col span={12} className="text-left">
                                    <span>
                                      {`${item?.user?.first_name} ${item?.user?.last_name}`}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Option>
                        );
                      })}
                    </Select>

                    <Row justify="start">
                      <Col span={22}>
                        <span className="danger-color text-left">
                          {customError.subdriver_id_Error &&
                            customError.subdriver_id_Error}
                        </span>
                      </Col>
                    </Row>
                  </Col>



                  {/* <Col
                    span={20}
                    className="text-start"
                  // style={{ paddingTop: "10px" }}
                  >
                    <Row justify="center">
                      <Col span={24} className="text-start">
                        <RadioWrapper
                          onChange={(e) =>
                            this.setState({
                              driver_id: e.target.value,
                              radioValue: "",
                            })
                          }
                          checked={!this.state.radioValue}
                          value="driver_id"
                        />
                        <span>Dispatch Immediately</span>
                      </Col>
                    </Row>
                  </Col> */}


                  {/* <Col
                    span={20}
                    style={{ paddingTop: "10px", paddingBottom: "10px" }}
                  >
                    <Row justify="center">
                      <Col span={24}>
                        <Row gutter={[10, 10]}>
                          <Col span={10}>
                            <RadioWrapper
                              checked={this.state.radioValue === "start_time"}
                              onChange={(e) =>
                                this.setState({
                                  start_time: e.target.value,
                                  radioValue: "start_time",
                                })
                              }
                              value="start_time"
                            />
                            <span>Select Time</span>
                          </Col>
                          <Col span={5}>
                            <TextInput
                              type="text"
                              onChangeStyle={{
                                width: "100%",
                                height: "40px",
                                marginTop: "-20px",
                              }}
                              onChange={(e) =>
                                this.setState({
                                  setHours: e.target.value,
                                  ...customError,
                                  customError: {
                                    setHours_Error: "",
                                  },
                                })
                              }
                              disabled={!this.state.radioValue}
                              value={setHours}
                              maxLength="2"
                            />
                          </Col>
                          <Col span={1}>:</Col>
                          <Col span={5}>
                            <TextInput
                              type="text"
                              onChangeStyle={{
                                width: "100%",
                                height: "40px",
                                marginTop: "-20px",
                              }}
                              onChange={(e) =>
                                this.setState({
                                  setMin: e.target.value,
                                  customError: {
                                    ...customError,
                                    setHours_Error: "",
                                  },
                                })
                              }
                              value={setMin}
                              disabled={!this.state.radioValue}
                              maxLength="2"
                            />
                          </Col>
                          <Col span={3}>
                            <span
                              className="am-circle am-pm-circle"
                              style={{
                                marginTop: "-5px",
                              }}
                            >
                              {OrderDetail?.preferred_delivery_period}
                            </span>
                          </Col>
                        </Row>
                        <Row justify="start">
                          <Col>
                            <span className="danger-color text-left">
                              {customError.setHours_Error &&
                                customError.setHours_Error}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col> */}

                  <Col span={20}>
                    <Divider />
                  </Col>

                  <ul id="scroller">
                    {(this.props.log_partner || []).map((item) => {
                      return (
                        <li>
                          <span span={4}>
                            <img
                              src={item.users?.[0]?.image?.original}
                              height={"50"}
                              width={"50"}
                              style={{ borderRadius: "50%" }}
                            />
                          </span>
                          <span span={24}>
                            <p className="three-dot">
                              {item.users?.[0]?.first_name}{" "}
                              {item.users?.[0]?.last_name}
                            </p>{" "}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </Row>
                : ""
                // end assign order modal dispatch and pending
              }
            </CustomModal >


            <CustomModal
              visible={this.state.isOpenModal}
              onCancelModal={this.onCancelModal}
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    className="d-flex justify-content-center"
                    style={{ width: "100%" }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#26a69a ",
                        color: "#fff",
                        width: "50%",
                        border: "none",
                      }}
                      onClick={() => {
                        this.setState({
                          isDispatchModal: true,
                        });
                        this.props.getLogisticsReq();
                        this.props.getLogPartnerReq();
                      }}
                    >
                      ACCEPT & DISPATCH
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() =>
                        approvedOrder(
                          OrderDetail.id,
                          () => {
                            this.onCancelModal();
                            this.props.history.push("/dashboard");
                          },
                          "approval"
                        )
                      }
                    >
                      APPROVE
                    </Button>
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col className="d-flex justify-content-center" span={24}>
                  <h1 className="st-primary">Approve Order</h1>
                </Col>
                <Col span={12} style={{ textAlign: "center" }}>
                  <span>Are you sure you want to approve this order?</span>
                </Col>
              </Row>
            </CustomModal>

            <CustomModal
              visible={this.state.isOpenReject}
              onCancelModal={() =>
                this.setState({
                  isOpenReject: false,
                })
              }
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    className="d-flex justify-content-center"
                    style={{ width: "100%" }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() =>
                        approvedOrder(
                          OrderDetail.id,
                          () => {
                            this.setState({
                              isOpenReject: false,
                            });
                            this.props.history.push("/dashboard");
                          },
                          "reject"
                        )
                      }
                    >
                      YES
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#26a69a ",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() =>
                        this.setState({
                          isOpenReject: false,
                        })
                      }
                    >
                      NO
                    </Button>
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col className="d-flex justify-content-center" span={24}>
                  <img src={Delete_order} />
                </Col>
                <Col span={12} style={{ textAlign: "center" }}>
                  <span>Are you sure you want to reject this order?</span>
                </Col>
              </Row>
            </CustomModal>

            <input
              type="file"
              ref={(ref) => (inputRef = ref)}
              accept=".docx,.pdf"
              className="d-none"
              onChange={(e) => {
                this.props.uploadDocReq(
                  OrderDetail.id,
                  {
                    attachment: e.target.files[0],
                    file: e.target.files[0],
                    uploader_user_id: this.props?.user?.[0]?.user?.id,
                    // assign_driver: this.state.assestDriverId
                  },
                  {
                    params: this.state.isTesting
                      ? "test_documents"
                      : "documents",
                  }
                );
              }}
            />

            <CustomModal
              visible={this.state.isOpenViewMix}
              onCancelModal={() =>
                this.setState({
                  isOpenViewMix: false,
                })
              }
              className="view-mix-modal"
              width={700}
              footer={[
                <Row justify="end">
                  <Col span={24} style={{ width: "100%" }}>
                    <Button
                      style={{
                        backgroundColor: "#ff9800 ",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() =>
                        this.setState({
                          isOpenViewMix: false,
                        })
                      }
                    >
                      Close
                    </Button>
                  </Col>
                </Row>,
              ]}
            >
              <Row
                justify="center"
                style={{ marginBottom: "30px" }}
                gutter={[10, 0]}
              >
                <Col>
                  <span className="modal-headning st-primary">
                    {viewMixDetail?.rmx_product?.name}
                  </span>
                </Col>

                <Divider />
              </Row>
              <Row>
                <Col span={9}>
                  <img
                    src={viewMixDetail?.rmx_product?.image?.medium}
                    style={{ objectFit: "contain", width: "90%" }}
                  />
                </Col>
                <Col
                  span={14}
                  style={{ border: "1px solid #F0F0F0", padding: "0.5rem" }}
                >
                  <Row>
                    <Col span={12} style={{ position: "relative" }}>
                      <img
                        src={Configuration}
                        style={{
                          width: "100%",
                          position: "absolute",
                          backgroundRepeat: "no-repeat",
                          top: "-20px",
                        }}
                      />
                    </Col>
                    {!!filterViewMix.length ? (
                      <Col
                        span={24}
                        style={{
                          height: "8rem",
                          overflowY: "auto",
                          overflowX: "hidden",
                          margin: "5px",
                        }}
                      >
                        {filterViewMix.map((item) => {
                          return (
                            <p style={{ marginTop: "35px" }}>
                              {item?.rmx_product_additive?.name}
                            </p>
                          );
                        })}

                        {/* {OrderDetail?.order_products?.order_product_additives.map()(
                    (item) => {
                      console.log("itemmss==>", item);
                      return (
                        <p style={{ marginTop: "35px" }}>
                          {item?.rmx_product_additive?.name}
                        </p>
                      );
                    }
                  )} */}
                      </Col>
                    ) : (
                      <Col span={24} style={{ margin: "3.5rem" }}>
                        <span
                          style={{
                            margin: "auto",
                            color: "#e0e0e0",
                            textAlign: "center",
                            fontSize: "16px",
                          }}
                        >
                          Nothing to show right now.
                        </span>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </CustomModal>

            <CustomModal
              visible={isOpenCheckList}
              onCancelModal={() =>
                this.setState({
                  isOpenCheckList: false,
                })
              }
              closable={false}
              width={500}
              className="checklist-modal"
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "lightgrey",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() =>
                        this.setState({
                          isOpenCheckList: false,
                        })
                      }
                    >
                      Close
                    </Button>
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h2 className="text-center st-primary">
                    {this.state.checkListData[listIndex]?.title}
                  </h2>
                  <Divider />
                </Col>
                {(this.state.checkListData[listIndex]?.question || []).map(
                  (v) => {
                    return (
                      <Col span={24} style={{ margin: "0.5rem" }}>
                        <input type="checkbox" class="c2" checked={v.value} />

                        <span className="text-left" style={{ margin: "1rem" }}>
                          {v.name}
                        </span>
                      </Col>
                    );
                  }
                )}
              </Row>
              {checklistAction === "drop_order" && (
                <Row justify="center" style={{ marginTop: "3rem" }}>
                  <Col span={1}>
                    {" "}
                    <BsCircleFill
                      color={listIndex === 0 ? "#4CAF50" : "#E0E0E0"}
                      className="pointer-cursor"
                      onClick={() => this.setState({ listIndex: 0 })}
                    />{" "}
                  </Col>
                  <Col span={1}>
                    {" "}
                    <BsCircleFill
                      color={listIndex === 1 ? "#4CAF50" : "#E0E0E0"}
                      className="pointer-cursor"
                      onClick={() => this.setState({ listIndex: 1 })}
                    />{" "}
                  </Col>
                </Row>
              )}
            </CustomModal>

            <div style={{ display: "none" }}>
              <Image.PreviewGroup
                preview={{
                  visible: this.state.isVisible,
                  onVisibleChange: (vis) =>
                    this.setState({
                      isVisible: vis,
                      assestDriverId: ""
                    }),
                }}
              >
                {(OrderDetail?.order_assets?.images || []).map((item) => {

                  if (item.userable_id == this.state.assestDriverId) {

                    return <Image src={item?.attachment?.original} />;
                  }
                })}
              </Image.PreviewGroup>
            </div>

            <CustomModal
              visible={this.state.isVisibleVideo}
              onCancelModal={() =>
                this.setState({
                  isVisibleVideo: false,
                  assestDriverId: ""

                })
              }
              // className="audio-video-mix-modal  modal-custom-height"
              width={700}
              footer={[
                <Col span={24}>
                  <Row justify="center">
                    {(OrderDetail?.order_assets?.videos || []).map(
                      (item, index) => {
                        return (
                          <Col
                            span={2}
                            className="pointer-cursor d-flex justify-content-center"
                            onClick={() => {
                              this.setState({
                                videoIndex: index,
                                attachment:
                                  OrderDetail?.order_assets?.videos?.[index]
                                    ?.attachment,
                              });
                            }}
                          >
                            <BsFillCameraReelsFill
                              size="25"
                              color={index == videoIndex ? "grey" : "black"}
                            />
                          </Col>
                        );
                      }
                    )}
                  </Row>
                </Col>,
              ]}
            >
              <Row justify="center">
                <Col span={24} className="d-flex justify-content-center">
                  <ReactPlayer
                    controls
                    url={
                      OrderDetail?.order_assets?.videos?.[videoIndex]
                        ?.attachment
                    }
                    height={250}
                    playing={this.state.isVisibleVideo}
                  // stopOnUnmount={true}
                  />
                </Col>
              </Row>
            </CustomModal>

            <CustomModal
              visible={this.state.isVisibleAudio}
              onCancelModal={() =>
                this.setState({
                  isVisibleAudio: false,
                  assestDriverId: ""
                })
              }
              // className="audio-video-mix-modal  modal-custom-height"
              width={700}
              footer={[
                <Col span={24}>
                  <Row justify="center">
                    {(OrderDetail?.order_assets?.audios || []).map(
                      (item, index) => {
                        if (item.userable_id == this.state.assestDriverId) {
                          return (
                            <Col
                              span={24}
                              className="pointer-cursor d-flex justify-content-center"
                              onClick={() => {
                                this.setState({
                                  audioIndex: index,
                                  attachment:
                                    OrderDetail?.order_assets?.audios?.[index]
                                      ?.attachment,
                                });
                              }}
                            >
                              <MdAudiotrack
                                size="25"
                                color={index == audioIndex ? "grey" : "black"}
                              />
                            </Col>
                          );
                        }
                      }
                    )}
                  </Row>
                </Col>,
              ]}
            >
              <Row justify="center">
                <Col span={24} className="d-flex justify-content-center">
                  <ReactPlayer
                    controls
                    url={
                      OrderDetail?.order_assets?.audios?.[audioIndex]
                        ?.attachment
                    }
                    height={250}
                    playing={isVisibleAudio}
                  />
                </Col>
              </Row>
            </CustomModal>

            <CustomModal
              visible={this.state.isOpenNotesModal}
              onCancelModal={() =>
                this.setState({
                  isOpenNotesModal: false,
                  assestDriverId: "",
                  noteShowOnModal: ""
                })
              }
              footer={[
              ]}
            >

              <Row justify="center">
                <Col span={24}>
                  <h6
                    style={{ color: "#09c1b2", fontSize: "1rem" }}
                    className="text-left"
                  >
                    NOTES
                  </h6>
                </Col>
                <Col
                  span={24}
                  className="d-flex text-left"
                  style={{ width: "100%", marginTop: '1rem' }}
                >
                  <span className="text-left">{this.state.noteShowOnModal}</span>
                </Col>
              </Row>
            </CustomModal>












            <CustomModal
              className="distance-modal"
              visible={this.state.distanceModal}
              onCancelModal={() =>
                this.setState({
                  distanceModal: false,
                  assestDriverId: ""
                })
              }
              footer={[
                <Row justify="start" style={{ margin: "20px" }}>
                  <Col
                    span={12}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    <h6
                      style={{ color: "#09c1b2", fontSize: "1rem" }}
                      className="text-left"
                    >
                      Starting Point:
                    </h6>
                  </Col>
                  <Col
                    span={12}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >

                    {
                      OrderDetail?.driver_orders.map((itm, ind) => {
                        if (itm.user.id == this.state.assestDriverId) {
                          return <span className="text-left">
                            {`(${itm.start_lat ? itm.start_lat : "0.00"} , ${itm.start_long ? itm.start_long : "0.00"})`}
                          </span>
                        }
                      })

                    }


                  </Col>
                  <Col
                    span={12}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    <h6
                      style={{ color: "#09c1b2", fontSize: "1rem" }}
                      className="text-left"
                    >
                      Ending Point:
                    </h6>
                  </Col>
                  <Col
                    span={12}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    {
                      OrderDetail?.driver_orders.map((itm, ind) => {
                        if (itm.user.id == this.state.assestDriverId) {
                          return <span className="text-left">
                            {`(${itm.end_lat ? itm.end_lat : "0.00"} , ${itm.end_long ? itm.end_long : "0.00"})`}
                          </span>
                        }
                      })

                    }
                  </Col>
                  <Col
                    span={12}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    <h6
                      style={{ color: "#09c1b2", fontSize: "1rem" }}
                      className="text-left"
                    >
                      Distance Travelled
                    </h6>
                  </Col>
                  <Col
                    span={12}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    {
                      OrderDetail?.driver_orders.map((itm, ind) => {
                        if (itm.user.id == this.state.assestDriverId) {
                          return <span className="text-left">
                            {getMiles(itm?.distance).toFixed(2)}
                            mi
                          </span>
                        }
                      })

                    }

                  </Col>
                </Row>,
              ]}
            ></CustomModal>
          </Row >
        ) : (
          <Row justify="center">
            <Col>
              {this.props.isLoadingCount && (
                <img src={LoaderGif} height={"60"} width={"60"} />
              )}
            </Col>
          </Row>
        )
        }
      </>
    );
  }
}
const mapStateToProps = (store) => {
  return {
    OrderDetail: store.DashboardReducer.orderDetail,
    user: store.AuthReducer.user,
    logistics: store.DashboardReducer.logistics,
    log_partner: store.DashboardReducer.log_partner,
    isLoadingCount: store.DashboardReducer.isLodadingCount,
    isLoader: store?.DashboardReducer?.isLoader,
    pavers: store.UserReducer.pavers,
    paversLoading: store.UserReducer.isLoading,

  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getOrderDetail: (id) => dispatch(DashboardAction.getOrderDetailReq(id)),
    approvedOrder: (id, cb, params, logId) =>
      dispatch(DashboardAction.OrderApprovalReq(id, cb, params, logId)),
    deleteDocReq: (orderId, docId, cb) =>
      dispatch(DashboardAction.deleteDocReq(orderId, docId, cb)),
    uploadDocReq: (orderId, payload, cb) =>
      dispatch(DashboardAction.uploadDocReq(orderId, payload, cb)),
    getLogisticsReq: () => dispatch(DashboardAction.getLogisticsReq()),
    getLogPartnerReq: () => dispatch(DashboardAction.getLogPartnerReq()),

    postLogisticsOrder: (id, payload, cb) =>
      dispatch(DashboardAction.postLogisticOrderReq(id, payload, cb)),
    assignPaver: (id, payload, cb) =>
      dispatch(DashboardAction.postAssignPaverReq(id, payload, cb)),
    markAsFav: (id) => dispatch(DashboardAction.markAsFavReq(id)),
    dispatchPendingOrder: (id, payload, cb) => dispatch(DashboardAction.dispatchOrderRequest(id, payload, cb)),
    getAllPavers: (filter) => dispatch(UserAction.getAllPaversReq('', filter)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderDetail);
